"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApi = exports.ServiceApiFactory = exports.ServiceApiFp = exports.ServiceApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
const common_1 = require("../common");
const base_1 = require("../base");
const ServiceApiAxiosParamCreator = function (configuration) {
    return {
        addFeatureFlag: async (featureFlag, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('addFeatureFlag', 'featureFlag', featureFlag);
            (0, common_1.assertParamExists)('addFeatureFlag', 'sellerId', sellerId);
            const localVarPath = `/v1/customer/{sellerId}/featureFlag/add/{featureFlag}`
                .replace(`{${"featureFlag"}}`, encodeURIComponent(String(featureFlag)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        cancel: async (orderId, cancelRequest, options = {}) => {
            (0, common_1.assertParamExists)('cancel', 'orderId', orderId);
            (0, common_1.assertParamExists)('cancel', 'cancelRequest', cancelRequest);
            const localVarPath = `/v1/order/{orderId}/cancel`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cancelRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        cancelShipment: async (freightShipmentId, freightShipmentCancelRequest, options = {}) => {
            (0, common_1.assertParamExists)('cancelShipment', 'freightShipmentId', freightShipmentId);
            (0, common_1.assertParamExists)('cancelShipment', 'freightShipmentCancelRequest', freightShipmentCancelRequest);
            const localVarPath = `/v1/freight/shipment/cancel/{freightShipmentId}`
                .replace(`{${"freightShipmentId"}}`, encodeURIComponent(String(freightShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightShipmentCancelRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        create: async (orderRequest, options = {}) => {
            (0, common_1.assertParamExists)('create', 'orderRequest', orderRequest);
            const localVarPath = `/v1/order`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orderRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createAddressLoadingDockScanEvent: async (loadingDockScanEventRequestWithAddress, options = {}) => {
            (0, common_1.assertParamExists)('createAddressLoadingDockScanEvent', 'loadingDockScanEventRequestWithAddress', loadingDockScanEventRequestWithAddress);
            const localVarPath = `/v1/pallet-event/address-loading-dock-scan-event`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loadingDockScanEventRequestWithAddress, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createContainerFreightStationV1: async (containerFreightStationData, options = {}) => {
            (0, common_1.assertParamExists)('createContainerFreightStationV1', 'containerFreightStationData', containerFreightStationData);
            const localVarPath = `/v1/container-freight-station`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(containerFreightStationData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createDrayage: async (drayageRequest, options = {}) => {
            (0, common_1.assertParamExists)('createDrayage', 'drayageRequest', drayageRequest);
            const localVarPath = `/v1/order/drayage`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(drayageRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createDrayageOrder: async (drayageOrderRequest, options = {}) => {
            (0, common_1.assertParamExists)('createDrayageOrder', 'drayageOrderRequest', drayageOrderRequest);
            const localVarPath = `/v2/order/drayage`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(drayageOrderRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createFclOrder: async (fclOrderRequest, options = {}) => {
            (0, common_1.assertParamExists)('createFclOrder', 'fclOrderRequest', fclOrderRequest);
            const localVarPath = `/v2/order/fcl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fclOrderRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createFreightForwarder: async (freightForwarderData, options = {}) => {
            (0, common_1.assertParamExists)('createFreightForwarder', 'freightForwarderData', freightForwarderData);
            const localVarPath = `/v1/freight-forwarder`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightForwarderData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createFreightTrackingInfo: async (sellerId, freightTrackingInfoData, options = {}) => {
            (0, common_1.assertParamExists)('createFreightTrackingInfo', 'sellerId', sellerId);
            (0, common_1.assertParamExists)('createFreightTrackingInfo', 'freightTrackingInfoData', freightTrackingInfoData);
            const localVarPath = `/v1/freight/tracking/{sellerId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightTrackingInfoData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createFtl: async (ftlRequest, options = {}) => {
            (0, common_1.assertParamExists)('createFtl', 'ftlRequest', ftlRequest);
            const localVarPath = `/v1/order/ftl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ftlRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createFtlOrder: async (ftlOrderRequest, options = {}) => {
            (0, common_1.assertParamExists)('createFtlOrder', 'ftlOrderRequest', ftlOrderRequest);
            const localVarPath = `/v2/order/ftl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ftlOrderRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createFtlShipment: async (freightFtlRequestWithCustomFieldsTsoaFix, options = {}) => {
            (0, common_1.assertParamExists)('createFtlShipment', 'freightFtlRequestWithCustomFieldsTsoaFix', freightFtlRequestWithCustomFieldsTsoaFix);
            const localVarPath = `/v2/freight/shipment/ftl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightFtlRequestWithCustomFieldsTsoaFix, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createLtl: async (ltlRequest, options = {}) => {
            (0, common_1.assertParamExists)('createLtl', 'ltlRequest', ltlRequest);
            const localVarPath = `/v1/order/ltl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ltlRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createLtlMetroPickupAndDeliveryShipment: async (freightLtlRequestWithCustomFieldsTsoaFix, options = {}) => {
            (0, common_1.assertParamExists)('createLtlMetroPickupAndDeliveryShipment', 'freightLtlRequestWithCustomFieldsTsoaFix', freightLtlRequestWithCustomFieldsTsoaFix);
            const localVarPath = `/v2/freight/shipment/ltl-metro-p-d`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightLtlRequestWithCustomFieldsTsoaFix, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createLtlOrder: async (ltlOrderRequest, options = {}) => {
            (0, common_1.assertParamExists)('createLtlOrder', 'ltlOrderRequest', ltlOrderRequest);
            const localVarPath = `/v2/order/ltl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ltlOrderRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createLtlShipment: async (freightLtlRequestWithCustomFieldsTsoaFix, options = {}) => {
            (0, common_1.assertParamExists)('createLtlShipment', 'freightLtlRequestWithCustomFieldsTsoaFix', freightLtlRequestWithCustomFieldsTsoaFix);
            const localVarPath = `/v2/freight/shipment/ltl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightLtlRequestWithCustomFieldsTsoaFix, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createOceanRateCard: async (oceanRateCardData, options = {}) => {
            (0, common_1.assertParamExists)('createOceanRateCard', 'oceanRateCardData', oceanRateCardData);
            const localVarPath = `/v1/freight-forwarder/ocean-rate-card`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(oceanRateCardData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createPartialFtlShipment: async (freightFtlRequestWithCustomFieldsTsoaFix, options = {}) => {
            (0, common_1.assertParamExists)('createPartialFtlShipment', 'freightFtlRequestWithCustomFieldsTsoaFix', freightFtlRequestWithCustomFieldsTsoaFix);
            const localVarPath = `/v2/freight/shipment/partial-ftl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightFtlRequestWithCustomFieldsTsoaFix, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createPort: async (portData, options = {}) => {
            (0, common_1.assertParamExists)('createPort', 'portData', portData);
            const localVarPath = `/v1/port`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(portData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createPricingStrategies: async (pricingStrategyDataWithRateData, options = {}) => {
            (0, common_1.assertParamExists)('createPricingStrategies', 'pricingStrategyDataWithRateData', pricingStrategyDataWithRateData);
            const localVarPath = `/v1/freight/pricing-strategies`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pricingStrategyDataWithRateData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createProfile: async (shipwellProfileCreatedEvent, options = {}) => {
            (0, common_1.assertParamExists)('createProfile', 'shipwellProfileCreatedEvent', shipwellProfileCreatedEvent);
            const localVarPath = `/v1/webhook/shipwell-profile`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipwellProfileCreatedEvent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createShipments: async (freightShipmentsCreateRequest, options = {}) => {
            (0, common_1.assertParamExists)('createShipments', 'freightShipmentsCreateRequest', freightShipmentsCreateRequest);
            const localVarPath = `/v2/freight/shipments`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightShipmentsCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createSupplier: async (supplierMerchantData, options = {}) => {
            (0, common_1.assertParamExists)('createSupplier', 'supplierMerchantData', supplierMerchantData);
            const localVarPath = `/v1/suppliers`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplierMerchantData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createSupplierContact: async (supplierId, createSupplierContactRequest, options = {}) => {
            (0, common_1.assertParamExists)('createSupplierContact', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('createSupplierContact', 'createSupplierContactRequest', createSupplierContactRequest);
            const localVarPath = `/v1/suppliers/{supplierId}/contact`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSupplierContactRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createSupplierLocation: async (supplierId, createSupplierLocationRequest, options = {}) => {
            (0, common_1.assertParamExists)('createSupplierLocation', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('createSupplierLocation', 'createSupplierLocationRequest', createSupplierLocationRequest);
            const localVarPath = `/v1/suppliers/{supplierId}/location`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSupplierLocationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createSupplierProduct: async (supplierId, createSupplierProductRequest, options = {}) => {
            (0, common_1.assertParamExists)('createSupplierProduct', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('createSupplierProduct', 'createSupplierProductRequest', createSupplierProductRequest);
            const localVarPath = `/v1/suppliers/{supplierId}/product`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSupplierProductRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createTransload: async (transloadFacilityData, options = {}) => {
            (0, common_1.assertParamExists)('createTransload', 'transloadFacilityData', transloadFacilityData);
            const localVarPath = `/v1/transload/facility`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(transloadFacilityData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createWarehouseLoadingDockScanEvent: async (loadingDockScanEventRequestWithWarehouseId, options = {}) => {
            (0, common_1.assertParamExists)('createWarehouseLoadingDockScanEvent', 'loadingDockScanEventRequestWithWarehouseId', loadingDockScanEventRequestWithWarehouseId);
            const localVarPath = `/v1/pallet-event/warehouse-loading-dock-scan-event`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loadingDockScanEventRequestWithWarehouseId, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteContainerFreightStationV1: async (id, options = {}) => {
            (0, common_1.assertParamExists)('deleteContainerFreightStationV1', 'id', id);
            const localVarPath = `/v1/container-freight-station/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteOceanRateCard: async (id, options = {}) => {
            (0, common_1.assertParamExists)('deleteOceanRateCard', 'id', id);
            const localVarPath = `/v1/freight-forwarder/ocean-rate-card/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteSupplier: async (supplierId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('deleteSupplier', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('deleteSupplier', 'sellerId', sellerId);
            const localVarPath = `/v1/suppliers/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteSupplierContact: async (supplierId, supplierContactId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('deleteSupplierContact', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('deleteSupplierContact', 'supplierContactId', supplierContactId);
            (0, common_1.assertParamExists)('deleteSupplierContact', 'sellerId', sellerId);
            const localVarPath = `/v1/suppliers/{supplierId}/contact/{supplierContactId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"supplierContactId"}}`, encodeURIComponent(String(supplierContactId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteSupplierLocation: async (supplierId, supplierLocationId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('deleteSupplierLocation', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('deleteSupplierLocation', 'supplierLocationId', supplierLocationId);
            (0, common_1.assertParamExists)('deleteSupplierLocation', 'sellerId', sellerId);
            const localVarPath = `/v1/suppliers/{supplierId}/location/{supplierLocationId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"supplierLocationId"}}`, encodeURIComponent(String(supplierLocationId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteSupplierProduct: async (supplierId, sellerId, productId, options = {}) => {
            (0, common_1.assertParamExists)('deleteSupplierProduct', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('deleteSupplierProduct', 'sellerId', sellerId);
            (0, common_1.assertParamExists)('deleteSupplierProduct', 'productId', productId);
            const localVarPath = `/v1/suppliers/{supplierId}/product/{productId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        dispatchByFreightRateId: async (freightRateId, options = {}) => {
            (0, common_1.assertParamExists)('dispatchByFreightRateId', 'freightRateId', freightRateId);
            const localVarPath = `/v2/freight/rates/{freightRateId}`
                .replace(`{${"freightRateId"}}`, encodeURIComponent(String(freightRateId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        enqueueMothershipWebhookEvent: async (body, options = {}) => {
            (0, common_1.assertParamExists)('enqueueMothershipWebhookEvent', 'body', body);
            const localVarPath = `/v1/freight/public/mothership/shipment/webhook/enqueue`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        enqueueOpenTrackWebhookEvent: async (body, options = {}) => {
            (0, common_1.assertParamExists)('enqueueOpenTrackWebhookEvent', 'body', body);
            const localVarPath = `/v1/freight/public/opentrack/webhook/enqueue`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        enqueueShipwellWebhookEvent: async (body, options = {}) => {
            (0, common_1.assertParamExists)('enqueueShipwellWebhookEvent', 'body', body);
            const localVarPath = `/v1/freight/public/shipwell/webhook/enqueue`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateChargeReportForSID: async (freightShipmentChargeReportRequest, options = {}) => {
            (0, common_1.assertParamExists)('generateChargeReportForSID', 'freightShipmentChargeReportRequest', freightShipmentChargeReportRequest);
            const localVarPath = `/v1/freight/shipment/report/charges`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightShipmentChargeReportRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateDrayageQuote: async (drayageQuoteRequestV2, options = {}) => {
            (0, common_1.assertParamExists)('generateDrayageQuote', 'drayageQuoteRequestV2', drayageQuoteRequestV2);
            const localVarPath = `/v3/quote/drayage`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(drayageQuoteRequestV2, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateFreightPlan: async (freightPlanRequest, options = {}) => {
            (0, common_1.assertParamExists)('generateFreightPlan', 'freightPlanRequest', freightPlanRequest);
            const localVarPath = `/v1/freight/plan`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightPlanRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateFreightPlanHashId: async (freightPlanId, options = {}) => {
            (0, common_1.assertParamExists)('generateFreightPlanHashId', 'freightPlanId', freightPlanId);
            const localVarPath = `/v1/freight/plan/{freightPlanId}/generate-hash-id`
                .replace(`{${"freightPlanId"}}`, encodeURIComponent(String(freightPlanId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateFreightQuote: async (freightQuoteRequest, options = {}) => {
            (0, common_1.assertParamExists)('generateFreightQuote', 'freightQuoteRequest', freightQuoteRequest);
            const localVarPath = `/v1/freight/quote`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightQuoteRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateFtlQuote: async (ftlQuoteRequestV2, options = {}) => {
            (0, common_1.assertParamExists)('generateFtlQuote', 'ftlQuoteRequestV2', ftlQuoteRequestV2);
            const localVarPath = `/v3/quote/ftl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ftlQuoteRequestV2, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateFtlQuoteV2: async (ftlQuoteRequest, options = {}) => {
            (0, common_1.assertParamExists)('generateFtlQuoteV2', 'ftlQuoteRequest', ftlQuoteRequest);
            const localVarPath = `/v2/quote/ftl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ftlQuoteRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateIntlOceanQuote: async (intlOceanQuoteRequest, options = {}) => {
            (0, common_1.assertParamExists)('generateIntlOceanQuote', 'intlOceanQuoteRequest', intlOceanQuoteRequest);
            const localVarPath = `/v3/quote/intl/ocean`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(intlOceanQuoteRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateLtlBatchQuote: async (ltlBatchQuoteRequest, options = {}) => {
            (0, common_1.assertParamExists)('generateLtlBatchQuote', 'ltlBatchQuoteRequest', ltlBatchQuoteRequest);
            const localVarPath = `/v3/quote/ltl/batch`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ltlBatchQuoteRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateLtlQuote: async (ltlQuoteRequestV2, options = {}) => {
            (0, common_1.assertParamExists)('generateLtlQuote', 'ltlQuoteRequestV2', ltlQuoteRequestV2);
            const localVarPath = `/v3/quote/ltl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ltlQuoteRequestV2, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateLtlQuoteV2: async (ltlQuoteRequest, options = {}) => {
            (0, common_1.assertParamExists)('generateLtlQuoteV2', 'ltlQuoteRequest', ltlQuoteRequest);
            const localVarPath = `/v2/quote/ltl`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ltlQuoteRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generatePalletLabels: async (sellerId, shippingPlanId, language, paperSize, options = {}) => {
            (0, common_1.assertParamExists)('generatePalletLabels', 'sellerId', sellerId);
            (0, common_1.assertParamExists)('generatePalletLabels', 'shippingPlanId', shippingPlanId);
            (0, common_1.assertParamExists)('generatePalletLabels', 'language', language);
            (0, common_1.assertParamExists)('generatePalletLabels', 'paperSize', paperSize);
            const localVarPath = `/v1/freight/seller/{sellerId}/shipping-plan/{shippingPlanId}/pallets/labels`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"shippingPlanId"}}`, encodeURIComponent(String(shippingPlanId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (paperSize !== undefined) {
                localVarQueryParameter['paperSize'] = paperSize;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateQuote: async (quoteRequest, options = {}) => {
            (0, common_1.assertParamExists)('generateQuote', 'quoteRequest', quoteRequest);
            const localVarPath = `/v1/quote`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(quoteRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateQuotes: async (requestForQuote, options = {}) => {
            (0, common_1.assertParamExists)('generateQuotes', 'requestForQuote', requestForQuote);
            const localVarPath = `/v1/quote-request`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestForQuote, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAllPorts: async (options = {}) => {
            const localVarPath = `/v1/port`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAllProfilesBySellerId: async (sellerId, status, options = {}) => {
            (0, common_1.assertParamExists)('getAllProfilesBySellerId', 'sellerId', sellerId);
            const localVarPath = `/v1/shipwell-profile`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAllTransloads: async (options = {}) => {
            const localVarPath = `/v1/transload/facility`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBol: async (orderId, bolId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getBol', 'orderId', orderId);
            (0, common_1.assertParamExists)('getBol', 'bolId', bolId);
            (0, common_1.assertParamExists)('getBol', 'sellerId', sellerId);
            const localVarPath = `/v1/order/{orderId}/bol/{bolId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"bolId"}}`, encodeURIComponent(String(bolId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBolPdfUrl: async (bolId, options = {}) => {
            (0, common_1.assertParamExists)('getBolPdfUrl', 'bolId', bolId);
            const localVarPath = `/v1/freight/bol/{bolId}`
                .replace(`{${"bolId"}}`, encodeURIComponent(String(bolId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBolTracking: async (bolId, options = {}) => {
            (0, common_1.assertParamExists)('getBolTracking', 'bolId', bolId);
            const localVarPath = `/v1/tracking/order-load/bol/{bolId}/events`
                .replace(`{${"bolId"}}`, encodeURIComponent(String(bolId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBolTrackingByBolId: async (bolId, options = {}) => {
            (0, common_1.assertParamExists)('getBolTrackingByBolId', 'bolId', bolId);
            const localVarPath = `/v1/freight/tracking/bol/{bolId}`
                .replace(`{${"bolId"}}`, encodeURIComponent(String(bolId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBolTrackingByBolIdUnauthenticated: async (bolId, options = {}) => {
            (0, common_1.assertParamExists)('getBolTrackingByBolIdUnauthenticated', 'bolId', bolId);
            const localVarPath = `/v1/freight/public/tracking/bol/{bolId}`
                .replace(`{${"bolId"}}`, encodeURIComponent(String(bolId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBolTrackingByFreightShipmentId: async (freightShipmentId, options = {}) => {
            (0, common_1.assertParamExists)('getBolTrackingByFreightShipmentId', 'freightShipmentId', freightShipmentId);
            const localVarPath = `/v1/freight/tracking/shipment/{freightShipmentId}`
                .replace(`{${"freightShipmentId"}}`, encodeURIComponent(String(freightShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBolTrackingUnauthenticated: async (bolId, options = {}) => {
            (0, common_1.assertParamExists)('getBolTrackingUnauthenticated', 'bolId', bolId);
            const localVarPath = `/v1/public/tracking/order-load/bol/{bolId}/events`
                .replace(`{${"bolId"}}`, encodeURIComponent(String(bolId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCheapestFreightRateConfig: async (cheapestRateConfigRequest, options = {}) => {
            (0, common_1.assertParamExists)('getCheapestFreightRateConfig', 'cheapestRateConfigRequest', cheapestRateConfigRequest);
            const localVarPath = `/v1/freight/min-rate-config`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cheapestRateConfigRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getContainerFreightStationV1: async (id, options = {}) => {
            (0, common_1.assertParamExists)('getContainerFreightStationV1', 'id', id);
            const localVarPath = `/v1/container-freight-station/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getContainerFreightStationsV1: async (cursor, limit, direction, options = {}) => {
            const localVarPath = `/v1/container-freight-station`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCustomFieldData: async (id, options = {}) => {
            (0, common_1.assertParamExists)('getCustomFieldData', 'id', id);
            const localVarPath = `/v1/freight/shipment/{id}/custom-fields`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCustomer: async (sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getCustomer', 'sellerId', sellerId);
            const localVarPath = `/v1/customer/{sellerId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCustomers: async (requestBody, options = {}) => {
            (0, common_1.assertParamExists)('getCustomers', 'requestBody', requestBody);
            const localVarPath = `/v1/customer`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCustomersV2: async (sellerIds, options = {}) => {
            (0, common_1.assertParamExists)('getCustomersV2', 'sellerIds', sellerIds);
            const localVarPath = `/v1/customer`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerIds) {
                localVarQueryParameter['sellerIds'] = sellerIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getEligibleFreightStrategies: async (eligibleFreightStrategyRequest, options = {}) => {
            (0, common_1.assertParamExists)('getEligibleFreightStrategies', 'eligibleFreightStrategyRequest', eligibleFreightStrategyRequest);
            const localVarPath = `/v1/freight/shipment/strategy`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eligibleFreightStrategyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getExistingLegByShipmentId: async (freightShipmentId, options = {}) => {
            (0, common_1.assertParamExists)('getExistingLegByShipmentId', 'freightShipmentId', freightShipmentId);
            const localVarPath = `/v1/leg/shipment/{freightShipmentId}`
                .replace(`{${"freightShipmentId"}}`, encodeURIComponent(String(freightShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFreightForwarder: async (id, options = {}) => {
            (0, common_1.assertParamExists)('getFreightForwarder', 'id', id);
            const localVarPath = `/v1/freight-forwarder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFreightForwarders: async (limit, cursor, direction, options = {}) => {
            const localVarPath = `/v1/freight-forwarder`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFreightShipmentById: async (id, options = {}) => {
            (0, common_1.assertParamExists)('getFreightShipmentById', 'id', id);
            const localVarPath = `/v1/freight/shipment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFreightShipmentByPalletLabelId: async (palletLabelId, options = {}) => {
            (0, common_1.assertParamExists)('getFreightShipmentByPalletLabelId', 'palletLabelId', palletLabelId);
            const localVarPath = `/v1/freight/pallet-label/{palletLabelId}/shipment`
                .replace(`{${"palletLabelId"}}`, encodeURIComponent(String(palletLabelId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFreightTrackingByBolIds: async (freightTrackingByBolIdsRequest, options = {}) => {
            (0, common_1.assertParamExists)('getFreightTrackingByBolIds', 'freightTrackingByBolIdsRequest', freightTrackingByBolIdsRequest);
            const localVarPath = `/v1/freight/tracking/bol-ids`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightTrackingByBolIdsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFreightTrackingInfo: async (sellerId, externalIdType, externalId, options = {}) => {
            (0, common_1.assertParamExists)('getFreightTrackingInfo', 'sellerId', sellerId);
            (0, common_1.assertParamExists)('getFreightTrackingInfo', 'externalIdType', externalIdType);
            (0, common_1.assertParamExists)('getFreightTrackingInfo', 'externalId', externalId);
            const localVarPath = `/v1/freight/tracking/{sellerId}/{externalIdType}/{externalId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"externalIdType"}}`, encodeURIComponent(String(externalIdType)))
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getLtlOrderItemPalletLabels: async (orderItemId, paperSize, language, downloader, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getLtlOrderItemPalletLabels', 'orderItemId', orderItemId);
            (0, common_1.assertParamExists)('getLtlOrderItemPalletLabels', 'paperSize', paperSize);
            (0, common_1.assertParamExists)('getLtlOrderItemPalletLabels', 'language', language);
            (0, common_1.assertParamExists)('getLtlOrderItemPalletLabels', 'downloader', downloader);
            const localVarPath = `/v1/ltl-order-item/{orderItemId}/pallet-labels`
                .replace(`{${"orderItemId"}}`, encodeURIComponent(String(orderItemId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (paperSize !== undefined) {
                localVarQueryParameter['paperSize'] = paperSize;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (downloader !== undefined) {
                localVarQueryParameter['downloader'] = downloader;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOceanRateCard: async (id, options = {}) => {
            (0, common_1.assertParamExists)('getOceanRateCard', 'id', id);
            const localVarPath = `/v1/freight-forwarder/ocean-rate-card/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOceanRateCards: async (limit, cursor, direction, id, freightForwarderId, shippingLine, pickupPortId, destinationPortId, price, transitDays, cargoUnit, expiresAt, createdAt, updatedAt, options = {}) => {
            const localVarPath = `/v1/freight-forwarder/ocean-rate-card`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (freightForwarderId !== undefined) {
                localVarQueryParameter['freightForwarderId'] = freightForwarderId;
            }
            if (shippingLine !== undefined) {
                localVarQueryParameter['shippingLine'] = shippingLine;
            }
            if (pickupPortId !== undefined) {
                localVarQueryParameter['pickupPortId'] = pickupPortId;
            }
            if (destinationPortId !== undefined) {
                localVarQueryParameter['destinationPortId'] = destinationPortId;
            }
            if (price !== undefined) {
                localVarQueryParameter['price'] = price;
            }
            if (transitDays !== undefined) {
                localVarQueryParameter['transitDays'] = transitDays;
            }
            if (cargoUnit !== undefined) {
                localVarQueryParameter['cargoUnit'] = cargoUnit;
            }
            if (expiresAt !== undefined) {
                localVarQueryParameter['expiresAt'] = (expiresAt instanceof Date) ?
                    expiresAt.toISOString() :
                    expiresAt;
            }
            if (createdAt !== undefined) {
                localVarQueryParameter['createdAt'] = (createdAt instanceof Date) ?
                    createdAt.toISOString() :
                    createdAt;
            }
            if (updatedAt !== undefined) {
                localVarQueryParameter['updatedAt'] = (updatedAt instanceof Date) ?
                    updatedAt.toISOString() :
                    updatedAt;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrder: async (orderId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getOrder', 'orderId', orderId);
            (0, common_1.assertParamExists)('getOrder', 'sellerId', sellerId);
            const localVarPath = `/v2/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderDocuments: async (orderId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getOrderDocuments', 'orderId', orderId);
            (0, common_1.assertParamExists)('getOrderDocuments', 'sellerId', sellerId);
            const localVarPath = `/v2/order/{orderId}/documents`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderItemBol: async (orderItemId, options = {}) => {
            (0, common_1.assertParamExists)('getOrderItemBol', 'orderItemId', orderItemId);
            const localVarPath = `/v1/order-item/{orderItemId}/bol`
                .replace(`{${"orderItemId"}}`, encodeURIComponent(String(orderItemId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderItemByShipmentId: async (freightShipmentId, options = {}) => {
            (0, common_1.assertParamExists)('getOrderItemByShipmentId', 'freightShipmentId', freightShipmentId);
            const localVarPath = `/v1/order-item/shipment/{freightShipmentId}`
                .replace(`{${"freightShipmentId"}}`, encodeURIComponent(String(freightShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderItemPalletLabels: async (orderItemId, paperSize, language, downloader, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getOrderItemPalletLabels', 'orderItemId', orderItemId);
            (0, common_1.assertParamExists)('getOrderItemPalletLabels', 'paperSize', paperSize);
            (0, common_1.assertParamExists)('getOrderItemPalletLabels', 'language', language);
            (0, common_1.assertParamExists)('getOrderItemPalletLabels', 'downloader', downloader);
            const localVarPath = `/v1/order-item/{orderItemId}/pallet-labels`
                .replace(`{${"orderItemId"}}`, encodeURIComponent(String(orderItemId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (paperSize !== undefined) {
                localVarQueryParameter['paperSize'] = paperSize;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (downloader !== undefined) {
                localVarQueryParameter['downloader'] = downloader;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderV1: async (orderId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getOrderV1', 'orderId', orderId);
            (0, common_1.assertParamExists)('getOrderV1', 'sellerId', sellerId);
            const localVarPath = `/v1/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrders: async (sellerId, limit, cursor, direction, options = {}) => {
            (0, common_1.assertParamExists)('getOrders', 'sellerId', sellerId);
            const localVarPath = `/v2/order`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrdersV1: async (sellerId, limit, cursor, direction, options = {}) => {
            (0, common_1.assertParamExists)('getOrdersV1', 'sellerId', sellerId);
            const localVarPath = `/v1/order`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPalletLabelsByCarrierBolId: async (carrierBolId, paperSize, language, downloader, options = {}) => {
            (0, common_1.assertParamExists)('getPalletLabelsByCarrierBolId', 'carrierBolId', carrierBolId);
            (0, common_1.assertParamExists)('getPalletLabelsByCarrierBolId', 'paperSize', paperSize);
            (0, common_1.assertParamExists)('getPalletLabelsByCarrierBolId', 'language', language);
            (0, common_1.assertParamExists)('getPalletLabelsByCarrierBolId', 'downloader', downloader);
            const localVarPath = `/v1/leg/carrier-bol/{carrierBolId}/pallet-labels`
                .replace(`{${"carrierBolId"}}`, encodeURIComponent(String(carrierBolId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (paperSize !== undefined) {
                localVarQueryParameter['paperSize'] = paperSize;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (downloader !== undefined) {
                localVarQueryParameter['downloader'] = downloader;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPlan: async (freightPlanId, options = {}) => {
            (0, common_1.assertParamExists)('getPlan', 'freightPlanId', freightPlanId);
            const localVarPath = `/v1/freight/plan/{freightPlanId}`
                .replace(`{${"freightPlanId"}}`, encodeURIComponent(String(freightPlanId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPlanFromHashId: async (freightPlanHashId, options = {}) => {
            (0, common_1.assertParamExists)('getPlanFromHashId', 'freightPlanHashId', freightPlanHashId);
            const localVarPath = `/v1/freight/public/plan/{freightPlanHashId}`
                .replace(`{${"freightPlanHashId"}}`, encodeURIComponent(String(freightPlanHashId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPort: async (portId, options = {}) => {
            (0, common_1.assertParamExists)('getPort', 'portId', portId);
            const localVarPath = `/v1/port/{portId}`
                .replace(`{${"portId"}}`, encodeURIComponent(String(portId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getProfileByShipwellProfileId: async (shipwellProfileId, options = {}) => {
            (0, common_1.assertParamExists)('getProfileByShipwellProfileId', 'shipwellProfileId', shipwellProfileId);
            const localVarPath = `/v1/shipwell-profile/{shipwellProfileId}`
                .replace(`{${"shipwellProfileId"}}`, encodeURIComponent(String(shipwellProfileId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getQuote: async (quoteId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getQuote', 'quoteId', quoteId);
            (0, common_1.assertParamExists)('getQuote', 'sellerId', sellerId);
            const localVarPath = `/v3/quote/{quoteId}`
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getQuoteRequestById: async (quoteRequestId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getQuoteRequestById', 'quoteRequestId', quoteRequestId);
            const localVarPath = `/v1/quote-request/{quoteRequestId}`
                .replace(`{${"quoteRequestId"}}`, encodeURIComponent(String(quoteRequestId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getQuoteRequests: async (sellerId, limit, offset, options = {}) => {
            const localVarPath = `/v1/quote-request`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getQuoteV1: async (quoteId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getQuoteV1', 'quoteId', quoteId);
            const localVarPath = `/v1/quote/{quoteId}`
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getQuotes: async (sellerId, limit, offset, cursor, direction, options = {}) => {
            const localVarPath = `/v3/quote`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getQuotesV1: async (sellerId, limit, offset, options = {}) => {
            const localVarPath = `/v1/quote`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRecentlyUsedAddresses: async (sellerId, pickup, options = {}) => {
            (0, common_1.assertParamExists)('getRecentlyUsedAddresses', 'sellerId', sellerId);
            const localVarPath = `/v1/order/{sellerId}/address`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (pickup !== undefined) {
                localVarQueryParameter['pickup'] = pickup;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSellerPricingStrategiesAndRates: async (sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getSellerPricingStrategiesAndRates', 'sellerId', sellerId);
            const localVarPath = `/v1/freight/seller/{sellerId}/pricing-strategies`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStrategiesAndRatesForSellerRequest: async (sellerId, freightMode, fromZip, toZip, options = {}) => {
            (0, common_1.assertParamExists)('getStrategiesAndRatesForSellerRequest', 'sellerId', sellerId);
            (0, common_1.assertParamExists)('getStrategiesAndRatesForSellerRequest', 'freightMode', freightMode);
            (0, common_1.assertParamExists)('getStrategiesAndRatesForSellerRequest', 'fromZip', fromZip);
            (0, common_1.assertParamExists)('getStrategiesAndRatesForSellerRequest', 'toZip', toZip);
            const localVarPath = `/v1/freight/seller/{sellerId}/pricing-strategies/filter`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (freightMode !== undefined) {
                localVarQueryParameter['freightMode'] = freightMode;
            }
            if (fromZip !== undefined) {
                localVarQueryParameter['fromZip'] = fromZip;
            }
            if (toZip !== undefined) {
                localVarQueryParameter['toZip'] = toZip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSupplier: async (supplierId, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('getSupplier', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('getSupplier', 'sellerId', sellerId);
            const localVarPath = `/v1/suppliers/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSupplierContactsBySupplierId: async (supplierId, sellerId, cursor, limit, direction, options = {}) => {
            (0, common_1.assertParamExists)('getSupplierContactsBySupplierId', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('getSupplierContactsBySupplierId', 'sellerId', sellerId);
            const localVarPath = `/v1/suppliers/{supplierId}/contacts`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSupplierLocationsBySupplierId: async (supplierId, sellerId, cursor, limit, direction, options = {}) => {
            (0, common_1.assertParamExists)('getSupplierLocationsBySupplierId', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('getSupplierLocationsBySupplierId', 'sellerId', sellerId);
            const localVarPath = `/v1/suppliers/{supplierId}/locations`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSupplierProductsBySupplierId: async (sellerId, supplierId, cursor, limit, direction, options = {}) => {
            (0, common_1.assertParamExists)('getSupplierProductsBySupplierId', 'sellerId', sellerId);
            (0, common_1.assertParamExists)('getSupplierProductsBySupplierId', 'supplierId', supplierId);
            const localVarPath = `/v1/suppliers/{supplierId}/products`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSuppliersBySellerId: async (sellerId, cursor, limit, direction, options = {}) => {
            (0, common_1.assertParamExists)('getSuppliersBySellerId', 'sellerId', sellerId);
            const localVarPath = `/v1/suppliers`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getTradingPartnerBookingFields: async (tradingPartner, mode, options = {}) => {
            (0, common_1.assertParamExists)('getTradingPartnerBookingFields', 'tradingPartner', tradingPartner);
            (0, common_1.assertParamExists)('getTradingPartnerBookingFields', 'mode', mode);
            const localVarPath = `/v1/trading-partner/booking-fields`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tradingPartner !== undefined) {
                localVarQueryParameter['tradingPartner'] = tradingPartner;
            }
            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getTransload: async (transloadId, options = {}) => {
            (0, common_1.assertParamExists)('getTransload', 'transloadId', transloadId);
            const localVarPath = `/v1/transload/facility/{transloadId}`
                .replace(`{${"transloadId"}}`, encodeURIComponent(String(transloadId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getWarehousesByAddressAndCapabilities: async (getWarehousesByAddressAndCapabilitiesRequest, options = {}) => {
            (0, common_1.assertParamExists)('getWarehousesByAddressAndCapabilities', 'getWarehousesByAddressAndCapabilitiesRequest', getWarehousesByAddressAndCapabilitiesRequest);
            const localVarPath = `/freight/warehouse/search`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getWarehousesByAddressAndCapabilitiesRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        markShipmentAsPendingForBilling: async (markShipmentAsPendingForBillingRequest, options = {}) => {
            (0, common_1.assertParamExists)('markShipmentAsPendingForBilling', 'markShipmentAsPendingForBillingRequest', markShipmentAsPendingForBillingRequest);
            const localVarPath = `/v1/freight/shipment/billing/pending`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(markShipmentAsPendingForBillingRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        queueOrderByOrderId: async (orderId, options = {}) => {
            (0, common_1.assertParamExists)('queueOrderByOrderId', 'orderId', orderId);
            const localVarPath = `/v1/order/{orderId}/queue`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        rateShop: async (freightRequest, options = {}) => {
            (0, common_1.assertParamExists)('rateShop', 'freightRequest', freightRequest);
            const localVarPath = `/v1/freight/rates`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        receiveAtCrossdock: async (poNum, receiveAtCrossdockRequest, options = {}) => {
            (0, common_1.assertParamExists)('receiveAtCrossdock', 'poNum', poNum);
            (0, common_1.assertParamExists)('receiveAtCrossdock', 'receiveAtCrossdockRequest', receiveAtCrossdockRequest);
            const localVarPath = `/v1/freight/shipment/{poNum}/pallets/receive-at-crossdock`
                .replace(`{${"poNum"}}`, encodeURIComponent(String(poNum)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(receiveAtCrossdockRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        receivePalletAtCrossdock: async (palletLabelId, receivePalletAtCrossdockRequest, options = {}) => {
            (0, common_1.assertParamExists)('receivePalletAtCrossdock', 'palletLabelId', palletLabelId);
            (0, common_1.assertParamExists)('receivePalletAtCrossdock', 'receivePalletAtCrossdockRequest', receivePalletAtCrossdockRequest);
            const localVarPath = `/v1/freight/pallet/{palletLabelId}/receive-at-crossdock`
                .replace(`{${"palletLabelId"}}`, encodeURIComponent(String(palletLabelId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(receivePalletAtCrossdockRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeFeatureFlag: async (featureFlag, sellerId, options = {}) => {
            (0, common_1.assertParamExists)('removeFeatureFlag', 'featureFlag', featureFlag);
            (0, common_1.assertParamExists)('removeFeatureFlag', 'sellerId', sellerId);
            const localVarPath = `/v1/customer/{sellerId}/featureFlag/remove/{featureFlag}`
                .replace(`{${"featureFlag"}}`, encodeURIComponent(String(featureFlag)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setIsInternal: async (sellerId, isInternal, options = {}) => {
            (0, common_1.assertParamExists)('setIsInternal', 'sellerId', sellerId);
            (0, common_1.assertParamExists)('setIsInternal', 'isInternal', isInternal);
            const localVarPath = `/v1/customer/{sellerId}/isInternal/{isInternal}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"isInternal"}}`, encodeURIComponent(String(isInternal)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        syncShipwellShipment: async (shipwellShipmentId, options = {}) => {
            (0, common_1.assertParamExists)('syncShipwellShipment', 'shipwellShipmentId', shipwellShipmentId);
            const localVarPath = `/v1/freight/shipwell/shipment/{shipwellShipmentId}`
                .replace(`{${"shipwellShipmentId"}}`, encodeURIComponent(String(shipwellShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        syncShipwellShipmentByExternalId: async (externalShipmentId, options = {}) => {
            (0, common_1.assertParamExists)('syncShipwellShipmentByExternalId', 'externalShipmentId', externalShipmentId);
            const localVarPath = `/v1/freight/shipwell/shipment/sync/{externalShipmentId}`
                .replace(`{${"externalShipmentId"}}`, encodeURIComponent(String(externalShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateByShipmentId: async (freightShipmentId, updateLegRequest, options = {}) => {
            (0, common_1.assertParamExists)('updateByShipmentId', 'freightShipmentId', freightShipmentId);
            (0, common_1.assertParamExists)('updateByShipmentId', 'updateLegRequest', updateLegRequest);
            const localVarPath = `/v1/leg/shipment/{freightShipmentId}`
                .replace(`{${"freightShipmentId"}}`, encodeURIComponent(String(freightShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateLegRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateContainerFreightStationV1: async (id, partialContainerFreightStationData, options = {}) => {
            (0, common_1.assertParamExists)('updateContainerFreightStationV1', 'id', id);
            (0, common_1.assertParamExists)('updateContainerFreightStationV1', 'partialContainerFreightStationData', partialContainerFreightStationData);
            const localVarPath = `/v1/container-freight-station/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partialContainerFreightStationData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateFlexportFreightTrackingInfoByProId: async (proId, partialFreightTrackingInfoData, options = {}) => {
            (0, common_1.assertParamExists)('updateFlexportFreightTrackingInfoByProId', 'proId', proId);
            (0, common_1.assertParamExists)('updateFlexportFreightTrackingInfoByProId', 'partialFreightTrackingInfoData', partialFreightTrackingInfoData);
            const localVarPath = `/v1/freight/tracking/flexport/{proId}`
                .replace(`{${"proId"}}`, encodeURIComponent(String(proId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partialFreightTrackingInfoData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateFreightForwarder: async (id, partialFreightForwarderData, options = {}) => {
            (0, common_1.assertParamExists)('updateFreightForwarder', 'id', id);
            (0, common_1.assertParamExists)('updateFreightForwarder', 'partialFreightForwarderData', partialFreightForwarderData);
            const localVarPath = `/v1/freight-forwarder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partialFreightForwarderData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateOceanRateCard: async (id, partialOceanRateCardData, options = {}) => {
            (0, common_1.assertParamExists)('updateOceanRateCard', 'id', id);
            (0, common_1.assertParamExists)('updateOceanRateCard', 'partialOceanRateCardData', partialOceanRateCardData);
            const localVarPath = `/v1/freight-forwarder/ocean-rate-card/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partialOceanRateCardData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateOrCreateFreightTrackingInfo: async (sellerId, freightTrackingInfoData, options = {}) => {
            (0, common_1.assertParamExists)('updateOrCreateFreightTrackingInfo', 'sellerId', sellerId);
            (0, common_1.assertParamExists)('updateOrCreateFreightTrackingInfo', 'freightTrackingInfoData', freightTrackingInfoData);
            const localVarPath = `/v1/freight/tracking/{sellerId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightTrackingInfoData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePort: async (portId, partialPortData, options = {}) => {
            (0, common_1.assertParamExists)('updatePort', 'portId', portId);
            (0, common_1.assertParamExists)('updatePort', 'partialPortData', partialPortData);
            const localVarPath = `/v1/port/{portId}`
                .replace(`{${"portId"}}`, encodeURIComponent(String(portId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partialPortData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePricingStrategies: async (updatePricingStrategyInput, options = {}) => {
            (0, common_1.assertParamExists)('updatePricingStrategies', 'updatePricingStrategyInput', updatePricingStrategyInput);
            const localVarPath = `/v1/freight/pricing-strategies`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePricingStrategyInput, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePricingStrategyRates: async (updatePricingStrategyRateInput, options = {}) => {
            (0, common_1.assertParamExists)('updatePricingStrategyRates', 'updatePricingStrategyRateInput', updatePricingStrategyRateInput);
            const localVarPath = `/v1/freight/pricing-strategy-rates`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePricingStrategyRateInput, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateProfile: async (shipwellProfileId, pickShipwellProfileStatus, options = {}) => {
            (0, common_1.assertParamExists)('updateProfile', 'shipwellProfileId', shipwellProfileId);
            (0, common_1.assertParamExists)('updateProfile', 'pickShipwellProfileStatus', pickShipwellProfileStatus);
            const localVarPath = `/v1/shipwell-profile/{shipwellProfileId}`
                .replace(`{${"shipwellProfileId"}}`, encodeURIComponent(String(shipwellProfileId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pickShipwellProfileStatus, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateSupplierById: async (updateSupplierMerchantRequest, options = {}) => {
            (0, common_1.assertParamExists)('updateSupplierById', 'updateSupplierMerchantRequest', updateSupplierMerchantRequest);
            const localVarPath = `/v1/suppliers`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSupplierMerchantRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateSupplierContact: async (supplierId, supplierContactId, updateSupplierContactRequest, options = {}) => {
            (0, common_1.assertParamExists)('updateSupplierContact', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('updateSupplierContact', 'supplierContactId', supplierContactId);
            (0, common_1.assertParamExists)('updateSupplierContact', 'updateSupplierContactRequest', updateSupplierContactRequest);
            const localVarPath = `/v1/suppliers/{supplierId}/contact/{supplierContactId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"supplierContactId"}}`, encodeURIComponent(String(supplierContactId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSupplierContactRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateSupplierLocationById: async (supplierId, updateSupplierLocationRequest, options = {}) => {
            (0, common_1.assertParamExists)('updateSupplierLocationById', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('updateSupplierLocationById', 'updateSupplierLocationRequest', updateSupplierLocationRequest);
            const localVarPath = `/v1/suppliers/{supplierId}/location`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSupplierLocationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateSupplierProduct: async (supplierId, productId, updateSupplierProductRequest, options = {}) => {
            (0, common_1.assertParamExists)('updateSupplierProduct', 'supplierId', supplierId);
            (0, common_1.assertParamExists)('updateSupplierProduct', 'productId', productId);
            (0, common_1.assertParamExists)('updateSupplierProduct', 'updateSupplierProductRequest', updateSupplierProductRequest);
            const localVarPath = `/v1/suppliers/{supplierId}/product/{productId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSupplierProductRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateTransload: async (transloadId, partialTransloadFacilityData, options = {}) => {
            (0, common_1.assertParamExists)('updateTransload', 'transloadId', transloadId);
            (0, common_1.assertParamExists)('updateTransload', 'partialTransloadFacilityData', partialTransloadFacilityData);
            const localVarPath = `/v1/transload/facility/{transloadId}`
                .replace(`{${"transloadId"}}`, encodeURIComponent(String(transloadId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partialTransloadFacilityData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadBolByExternalShipmentId: async (shipwellShipmentId, options = {}) => {
            (0, common_1.assertParamExists)('uploadBolByExternalShipmentId', 'shipwellShipmentId', shipwellShipmentId);
            const localVarPath = `/v1/freight/shipment/{shipwellShipmentId}/bol`
                .replace(`{${"shipwellShipmentId"}}`, encodeURIComponent(String(shipwellShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadCustomerBol: async (id, freightBolUploadRequest, options = {}) => {
            (0, common_1.assertParamExists)('uploadCustomerBol', 'id', id);
            (0, common_1.assertParamExists)('uploadCustomerBol', 'freightBolUploadRequest', freightBolUploadRequest);
            const localVarPath = `/v2/freight/shipment/{id}/bol`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(freightBolUploadRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        upsertCustomer: async (customerData, options = {}) => {
            (0, common_1.assertParamExists)('upsertCustomer', 'customerData', customerData);
            const localVarPath = `/v1/customer`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ServiceApiAxiosParamCreator = ServiceApiAxiosParamCreator;
const ServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ServiceApiAxiosParamCreator)(configuration);
    return {
        async addFeatureFlag(featureFlag, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFeatureFlag(featureFlag, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async cancel(orderId, cancelRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(orderId, cancelRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async cancelShipment(freightShipmentId, freightShipmentCancelRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelShipment(freightShipmentId, freightShipmentCancelRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async create(orderRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(orderRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createAddressLoadingDockScanEvent(loadingDockScanEventRequestWithAddress, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAddressLoadingDockScanEvent(loadingDockScanEventRequestWithAddress, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createContainerFreightStationV1(containerFreightStationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContainerFreightStationV1(containerFreightStationData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createDrayage(drayageRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDrayage(drayageRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createDrayageOrder(drayageOrderRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDrayageOrder(drayageOrderRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createFclOrder(fclOrderRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFclOrder(fclOrderRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createFreightForwarder(freightForwarderData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFreightForwarder(freightForwarderData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createFreightTrackingInfo(sellerId, freightTrackingInfoData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFreightTrackingInfo(sellerId, freightTrackingInfoData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createFtl(ftlRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFtl(ftlRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createFtlOrder(ftlOrderRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFtlOrder(ftlOrderRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createLtl(ltlRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLtl(ltlRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createLtlMetroPickupAndDeliveryShipment(freightLtlRequestWithCustomFieldsTsoaFix, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLtlMetroPickupAndDeliveryShipment(freightLtlRequestWithCustomFieldsTsoaFix, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createLtlOrder(ltlOrderRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLtlOrder(ltlOrderRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createLtlShipment(freightLtlRequestWithCustomFieldsTsoaFix, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLtlShipment(freightLtlRequestWithCustomFieldsTsoaFix, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createOceanRateCard(oceanRateCardData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOceanRateCard(oceanRateCardData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createPartialFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartialFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createPort(portData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPort(portData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createPricingStrategies(pricingStrategyDataWithRateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPricingStrategies(pricingStrategyDataWithRateData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createProfile(shipwellProfileCreatedEvent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProfile(shipwellProfileCreatedEvent, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createShipments(freightShipmentsCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShipments(freightShipmentsCreateRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createSupplier(supplierMerchantData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSupplier(supplierMerchantData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createSupplierContact(supplierId, createSupplierContactRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSupplierContact(supplierId, createSupplierContactRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createSupplierLocation(supplierId, createSupplierLocationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSupplierLocation(supplierId, createSupplierLocationRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createSupplierProduct(supplierId, createSupplierProductRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSupplierProduct(supplierId, createSupplierProductRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createTransload(transloadFacilityData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransload(transloadFacilityData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createWarehouseLoadingDockScanEvent(loadingDockScanEventRequestWithWarehouseId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWarehouseLoadingDockScanEvent(loadingDockScanEventRequestWithWarehouseId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteContainerFreightStationV1(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContainerFreightStationV1(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteOceanRateCard(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOceanRateCard(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteSupplier(supplierId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSupplier(supplierId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteSupplierContact(supplierId, supplierContactId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSupplierContact(supplierId, supplierContactId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteSupplierLocation(supplierId, supplierLocationId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSupplierLocation(supplierId, supplierLocationId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteSupplierProduct(supplierId, sellerId, productId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSupplierProduct(supplierId, sellerId, productId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async dispatchByFreightRateId(freightRateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dispatchByFreightRateId(freightRateId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async enqueueMothershipWebhookEvent(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enqueueMothershipWebhookEvent(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async enqueueOpenTrackWebhookEvent(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enqueueOpenTrackWebhookEvent(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async enqueueShipwellWebhookEvent(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enqueueShipwellWebhookEvent(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateChargeReportForSID(freightShipmentChargeReportRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateChargeReportForSID(freightShipmentChargeReportRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateDrayageQuote(drayageQuoteRequestV2, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDrayageQuote(drayageQuoteRequestV2, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateFreightPlan(freightPlanRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFreightPlan(freightPlanRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateFreightPlanHashId(freightPlanId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFreightPlanHashId(freightPlanId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateFreightQuote(freightQuoteRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFreightQuote(freightQuoteRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateFtlQuote(ftlQuoteRequestV2, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFtlQuote(ftlQuoteRequestV2, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateFtlQuoteV2(ftlQuoteRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFtlQuoteV2(ftlQuoteRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateIntlOceanQuote(intlOceanQuoteRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateIntlOceanQuote(intlOceanQuoteRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateLtlBatchQuote(ltlBatchQuoteRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLtlBatchQuote(ltlBatchQuoteRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateLtlQuote(ltlQuoteRequestV2, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLtlQuote(ltlQuoteRequestV2, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateLtlQuoteV2(ltlQuoteRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLtlQuoteV2(ltlQuoteRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generatePalletLabels(sellerId, shippingPlanId, language, paperSize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePalletLabels(sellerId, shippingPlanId, language, paperSize, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateQuote(quoteRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateQuote(quoteRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateQuotes(requestForQuote, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateQuotes(requestForQuote, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getAllPorts(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPorts(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getAllProfilesBySellerId(sellerId, status, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProfilesBySellerId(sellerId, status, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getAllTransloads(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTransloads(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getBol(orderId, bolId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBol(orderId, bolId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getBolPdfUrl(bolId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBolPdfUrl(bolId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getBolTracking(bolId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBolTracking(bolId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getBolTrackingByBolId(bolId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBolTrackingByBolId(bolId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getBolTrackingByBolIdUnauthenticated(bolId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBolTrackingByBolIdUnauthenticated(bolId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getBolTrackingByFreightShipmentId(freightShipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBolTrackingByFreightShipmentId(freightShipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getBolTrackingUnauthenticated(bolId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBolTrackingUnauthenticated(bolId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getCheapestFreightRateConfig(cheapestRateConfigRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheapestFreightRateConfig(cheapestRateConfigRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getContainerFreightStationV1(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContainerFreightStationV1(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getContainerFreightStationsV1(cursor, limit, direction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContainerFreightStationsV1(cursor, limit, direction, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getCustomFieldData(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomFieldData(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getCustomer(sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomer(sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getCustomers(requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomers(requestBody, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getCustomersV2(sellerIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersV2(sellerIds, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getEligibleFreightStrategies(eligibleFreightStrategyRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEligibleFreightStrategies(eligibleFreightStrategyRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getExistingLegByShipmentId(freightShipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExistingLegByShipmentId(freightShipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getFreightForwarder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreightForwarder(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getFreightForwarders(limit, cursor, direction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreightForwarders(limit, cursor, direction, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getFreightShipmentById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreightShipmentById(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getFreightShipmentByPalletLabelId(palletLabelId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreightShipmentByPalletLabelId(palletLabelId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getFreightTrackingByBolIds(freightTrackingByBolIdsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreightTrackingByBolIds(freightTrackingByBolIdsRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getFreightTrackingInfo(sellerId, externalIdType, externalId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreightTrackingInfo(sellerId, externalIdType, externalId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getLtlOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLtlOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOceanRateCard(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOceanRateCard(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOceanRateCards(limit, cursor, direction, id, freightForwarderId, shippingLine, pickupPortId, destinationPortId, price, transitDays, cargoUnit, expiresAt, createdAt, updatedAt, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOceanRateCards(limit, cursor, direction, id, freightForwarderId, shippingLine, pickupPortId, destinationPortId, price, transitDays, cargoUnit, expiresAt, createdAt, updatedAt, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOrder(orderId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrder(orderId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOrderDocuments(orderId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderDocuments(orderId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOrderItemBol(orderItemId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderItemBol(orderItemId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOrderItemByShipmentId(freightShipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderItemByShipmentId(freightShipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOrderV1(orderId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderV1(orderId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOrders(sellerId, limit, cursor, direction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(sellerId, limit, cursor, direction, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getOrdersV1(sellerId, limit, cursor, direction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrdersV1(sellerId, limit, cursor, direction, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPalletLabelsByCarrierBolId(carrierBolId, paperSize, language, downloader, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPalletLabelsByCarrierBolId(carrierBolId, paperSize, language, downloader, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPlan(freightPlanId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlan(freightPlanId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPlanFromHashId(freightPlanHashId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanFromHashId(freightPlanHashId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPort(portId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPort(portId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getProfileByShipwellProfileId(shipwellProfileId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileByShipwellProfileId(shipwellProfileId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getQuote(quoteId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuote(quoteId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getQuoteRequestById(quoteRequestId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuoteRequestById(quoteRequestId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getQuoteRequests(sellerId, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuoteRequests(sellerId, limit, offset, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getQuoteV1(quoteId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuoteV1(quoteId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getQuotes(sellerId, limit, offset, cursor, direction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuotes(sellerId, limit, offset, cursor, direction, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getQuotesV1(sellerId, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuotesV1(sellerId, limit, offset, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getRecentlyUsedAddresses(sellerId, pickup, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentlyUsedAddresses(sellerId, pickup, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getSellerPricingStrategiesAndRates(sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSellerPricingStrategiesAndRates(sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getStrategiesAndRatesForSellerRequest(sellerId, freightMode, fromZip, toZip, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategiesAndRatesForSellerRequest(sellerId, freightMode, fromZip, toZip, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getSupplier(supplierId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplier(supplierId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getSupplierContactsBySupplierId(supplierId, sellerId, cursor, limit, direction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierContactsBySupplierId(supplierId, sellerId, cursor, limit, direction, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getSupplierLocationsBySupplierId(supplierId, sellerId, cursor, limit, direction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierLocationsBySupplierId(supplierId, sellerId, cursor, limit, direction, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getSupplierProductsBySupplierId(sellerId, supplierId, cursor, limit, direction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierProductsBySupplierId(sellerId, supplierId, cursor, limit, direction, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getSuppliersBySellerId(sellerId, cursor, limit, direction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuppliersBySellerId(sellerId, cursor, limit, direction, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getTradingPartnerBookingFields(tradingPartner, mode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradingPartnerBookingFields(tradingPartner, mode, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getTransload(transloadId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransload(transloadId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getWarehousesByAddressAndCapabilities(getWarehousesByAddressAndCapabilitiesRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWarehousesByAddressAndCapabilities(getWarehousesByAddressAndCapabilitiesRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async markShipmentAsPendingForBilling(markShipmentAsPendingForBillingRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markShipmentAsPendingForBilling(markShipmentAsPendingForBillingRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async queueOrderByOrderId(orderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queueOrderByOrderId(orderId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async rateShop(freightRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rateShop(freightRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async receiveAtCrossdock(poNum, receiveAtCrossdockRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveAtCrossdock(poNum, receiveAtCrossdockRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async receivePalletAtCrossdock(palletLabelId, receivePalletAtCrossdockRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivePalletAtCrossdock(palletLabelId, receivePalletAtCrossdockRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async removeFeatureFlag(featureFlag, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFeatureFlag(featureFlag, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async setIsInternal(sellerId, isInternal, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setIsInternal(sellerId, isInternal, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async syncShipwellShipment(shipwellShipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncShipwellShipment(shipwellShipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async syncShipwellShipmentByExternalId(externalShipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncShipwellShipmentByExternalId(externalShipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateByShipmentId(freightShipmentId, updateLegRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateByShipmentId(freightShipmentId, updateLegRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateContainerFreightStationV1(id, partialContainerFreightStationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContainerFreightStationV1(id, partialContainerFreightStationData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateFlexportFreightTrackingInfoByProId(proId, partialFreightTrackingInfoData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFlexportFreightTrackingInfoByProId(proId, partialFreightTrackingInfoData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateFreightForwarder(id, partialFreightForwarderData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFreightForwarder(id, partialFreightForwarderData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateOceanRateCard(id, partialOceanRateCardData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOceanRateCard(id, partialOceanRateCardData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateOrCreateFreightTrackingInfo(sellerId, freightTrackingInfoData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrCreateFreightTrackingInfo(sellerId, freightTrackingInfoData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updatePort(portId, partialPortData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePort(portId, partialPortData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updatePricingStrategies(updatePricingStrategyInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePricingStrategies(updatePricingStrategyInput, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updatePricingStrategyRates(updatePricingStrategyRateInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePricingStrategyRates(updatePricingStrategyRateInput, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateProfile(shipwellProfileId, pickShipwellProfileStatus, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(shipwellProfileId, pickShipwellProfileStatus, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateSupplierById(updateSupplierMerchantRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupplierById(updateSupplierMerchantRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateSupplierContact(supplierId, supplierContactId, updateSupplierContactRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupplierContact(supplierId, supplierContactId, updateSupplierContactRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateSupplierLocationById(supplierId, updateSupplierLocationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupplierLocationById(supplierId, updateSupplierLocationRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateSupplierProduct(supplierId, productId, updateSupplierProductRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupplierProduct(supplierId, productId, updateSupplierProductRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateTransload(transloadId, partialTransloadFacilityData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransload(transloadId, partialTransloadFacilityData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async uploadBolByExternalShipmentId(shipwellShipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBolByExternalShipmentId(shipwellShipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async uploadCustomerBol(id, freightBolUploadRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCustomerBol(id, freightBolUploadRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async upsertCustomer(customerData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertCustomer(customerData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ServiceApiFp = ServiceApiFp;
const ServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ServiceApiFp)(configuration);
    return {
        addFeatureFlag(featureFlag, sellerId, options) {
            return localVarFp.addFeatureFlag(featureFlag, sellerId, options).then((request) => request(axios, basePath));
        },
        cancel(orderId, cancelRequest, options) {
            return localVarFp.cancel(orderId, cancelRequest, options).then((request) => request(axios, basePath));
        },
        cancelShipment(freightShipmentId, freightShipmentCancelRequest, options) {
            return localVarFp.cancelShipment(freightShipmentId, freightShipmentCancelRequest, options).then((request) => request(axios, basePath));
        },
        create(orderRequest, options) {
            return localVarFp.create(orderRequest, options).then((request) => request(axios, basePath));
        },
        createAddressLoadingDockScanEvent(loadingDockScanEventRequestWithAddress, options) {
            return localVarFp.createAddressLoadingDockScanEvent(loadingDockScanEventRequestWithAddress, options).then((request) => request(axios, basePath));
        },
        createContainerFreightStationV1(containerFreightStationData, options) {
            return localVarFp.createContainerFreightStationV1(containerFreightStationData, options).then((request) => request(axios, basePath));
        },
        createDrayage(drayageRequest, options) {
            return localVarFp.createDrayage(drayageRequest, options).then((request) => request(axios, basePath));
        },
        createDrayageOrder(drayageOrderRequest, options) {
            return localVarFp.createDrayageOrder(drayageOrderRequest, options).then((request) => request(axios, basePath));
        },
        createFclOrder(fclOrderRequest, options) {
            return localVarFp.createFclOrder(fclOrderRequest, options).then((request) => request(axios, basePath));
        },
        createFreightForwarder(freightForwarderData, options) {
            return localVarFp.createFreightForwarder(freightForwarderData, options).then((request) => request(axios, basePath));
        },
        createFreightTrackingInfo(sellerId, freightTrackingInfoData, options) {
            return localVarFp.createFreightTrackingInfo(sellerId, freightTrackingInfoData, options).then((request) => request(axios, basePath));
        },
        createFtl(ftlRequest, options) {
            return localVarFp.createFtl(ftlRequest, options).then((request) => request(axios, basePath));
        },
        createFtlOrder(ftlOrderRequest, options) {
            return localVarFp.createFtlOrder(ftlOrderRequest, options).then((request) => request(axios, basePath));
        },
        createFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options) {
            return localVarFp.createFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options).then((request) => request(axios, basePath));
        },
        createLtl(ltlRequest, options) {
            return localVarFp.createLtl(ltlRequest, options).then((request) => request(axios, basePath));
        },
        createLtlMetroPickupAndDeliveryShipment(freightLtlRequestWithCustomFieldsTsoaFix, options) {
            return localVarFp.createLtlMetroPickupAndDeliveryShipment(freightLtlRequestWithCustomFieldsTsoaFix, options).then((request) => request(axios, basePath));
        },
        createLtlOrder(ltlOrderRequest, options) {
            return localVarFp.createLtlOrder(ltlOrderRequest, options).then((request) => request(axios, basePath));
        },
        createLtlShipment(freightLtlRequestWithCustomFieldsTsoaFix, options) {
            return localVarFp.createLtlShipment(freightLtlRequestWithCustomFieldsTsoaFix, options).then((request) => request(axios, basePath));
        },
        createOceanRateCard(oceanRateCardData, options) {
            return localVarFp.createOceanRateCard(oceanRateCardData, options).then((request) => request(axios, basePath));
        },
        createPartialFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options) {
            return localVarFp.createPartialFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options).then((request) => request(axios, basePath));
        },
        createPort(portData, options) {
            return localVarFp.createPort(portData, options).then((request) => request(axios, basePath));
        },
        createPricingStrategies(pricingStrategyDataWithRateData, options) {
            return localVarFp.createPricingStrategies(pricingStrategyDataWithRateData, options).then((request) => request(axios, basePath));
        },
        createProfile(shipwellProfileCreatedEvent, options) {
            return localVarFp.createProfile(shipwellProfileCreatedEvent, options).then((request) => request(axios, basePath));
        },
        createShipments(freightShipmentsCreateRequest, options) {
            return localVarFp.createShipments(freightShipmentsCreateRequest, options).then((request) => request(axios, basePath));
        },
        createSupplier(supplierMerchantData, options) {
            return localVarFp.createSupplier(supplierMerchantData, options).then((request) => request(axios, basePath));
        },
        createSupplierContact(supplierId, createSupplierContactRequest, options) {
            return localVarFp.createSupplierContact(supplierId, createSupplierContactRequest, options).then((request) => request(axios, basePath));
        },
        createSupplierLocation(supplierId, createSupplierLocationRequest, options) {
            return localVarFp.createSupplierLocation(supplierId, createSupplierLocationRequest, options).then((request) => request(axios, basePath));
        },
        createSupplierProduct(supplierId, createSupplierProductRequest, options) {
            return localVarFp.createSupplierProduct(supplierId, createSupplierProductRequest, options).then((request) => request(axios, basePath));
        },
        createTransload(transloadFacilityData, options) {
            return localVarFp.createTransload(transloadFacilityData, options).then((request) => request(axios, basePath));
        },
        createWarehouseLoadingDockScanEvent(loadingDockScanEventRequestWithWarehouseId, options) {
            return localVarFp.createWarehouseLoadingDockScanEvent(loadingDockScanEventRequestWithWarehouseId, options).then((request) => request(axios, basePath));
        },
        deleteContainerFreightStationV1(id, options) {
            return localVarFp.deleteContainerFreightStationV1(id, options).then((request) => request(axios, basePath));
        },
        deleteOceanRateCard(id, options) {
            return localVarFp.deleteOceanRateCard(id, options).then((request) => request(axios, basePath));
        },
        deleteSupplier(supplierId, sellerId, options) {
            return localVarFp.deleteSupplier(supplierId, sellerId, options).then((request) => request(axios, basePath));
        },
        deleteSupplierContact(supplierId, supplierContactId, sellerId, options) {
            return localVarFp.deleteSupplierContact(supplierId, supplierContactId, sellerId, options).then((request) => request(axios, basePath));
        },
        deleteSupplierLocation(supplierId, supplierLocationId, sellerId, options) {
            return localVarFp.deleteSupplierLocation(supplierId, supplierLocationId, sellerId, options).then((request) => request(axios, basePath));
        },
        deleteSupplierProduct(supplierId, sellerId, productId, options) {
            return localVarFp.deleteSupplierProduct(supplierId, sellerId, productId, options).then((request) => request(axios, basePath));
        },
        dispatchByFreightRateId(freightRateId, options) {
            return localVarFp.dispatchByFreightRateId(freightRateId, options).then((request) => request(axios, basePath));
        },
        enqueueMothershipWebhookEvent(body, options) {
            return localVarFp.enqueueMothershipWebhookEvent(body, options).then((request) => request(axios, basePath));
        },
        enqueueOpenTrackWebhookEvent(body, options) {
            return localVarFp.enqueueOpenTrackWebhookEvent(body, options).then((request) => request(axios, basePath));
        },
        enqueueShipwellWebhookEvent(body, options) {
            return localVarFp.enqueueShipwellWebhookEvent(body, options).then((request) => request(axios, basePath));
        },
        generateChargeReportForSID(freightShipmentChargeReportRequest, options) {
            return localVarFp.generateChargeReportForSID(freightShipmentChargeReportRequest, options).then((request) => request(axios, basePath));
        },
        generateDrayageQuote(drayageQuoteRequestV2, options) {
            return localVarFp.generateDrayageQuote(drayageQuoteRequestV2, options).then((request) => request(axios, basePath));
        },
        generateFreightPlan(freightPlanRequest, options) {
            return localVarFp.generateFreightPlan(freightPlanRequest, options).then((request) => request(axios, basePath));
        },
        generateFreightPlanHashId(freightPlanId, options) {
            return localVarFp.generateFreightPlanHashId(freightPlanId, options).then((request) => request(axios, basePath));
        },
        generateFreightQuote(freightQuoteRequest, options) {
            return localVarFp.generateFreightQuote(freightQuoteRequest, options).then((request) => request(axios, basePath));
        },
        generateFtlQuote(ftlQuoteRequestV2, options) {
            return localVarFp.generateFtlQuote(ftlQuoteRequestV2, options).then((request) => request(axios, basePath));
        },
        generateFtlQuoteV2(ftlQuoteRequest, options) {
            return localVarFp.generateFtlQuoteV2(ftlQuoteRequest, options).then((request) => request(axios, basePath));
        },
        generateIntlOceanQuote(intlOceanQuoteRequest, options) {
            return localVarFp.generateIntlOceanQuote(intlOceanQuoteRequest, options).then((request) => request(axios, basePath));
        },
        generateLtlBatchQuote(ltlBatchQuoteRequest, options) {
            return localVarFp.generateLtlBatchQuote(ltlBatchQuoteRequest, options).then((request) => request(axios, basePath));
        },
        generateLtlQuote(ltlQuoteRequestV2, options) {
            return localVarFp.generateLtlQuote(ltlQuoteRequestV2, options).then((request) => request(axios, basePath));
        },
        generateLtlQuoteV2(ltlQuoteRequest, options) {
            return localVarFp.generateLtlQuoteV2(ltlQuoteRequest, options).then((request) => request(axios, basePath));
        },
        generatePalletLabels(sellerId, shippingPlanId, language, paperSize, options) {
            return localVarFp.generatePalletLabels(sellerId, shippingPlanId, language, paperSize, options).then((request) => request(axios, basePath));
        },
        generateQuote(quoteRequest, options) {
            return localVarFp.generateQuote(quoteRequest, options).then((request) => request(axios, basePath));
        },
        generateQuotes(requestForQuote, options) {
            return localVarFp.generateQuotes(requestForQuote, options).then((request) => request(axios, basePath));
        },
        getAllPorts(options) {
            return localVarFp.getAllPorts(options).then((request) => request(axios, basePath));
        },
        getAllProfilesBySellerId(sellerId, status, options) {
            return localVarFp.getAllProfilesBySellerId(sellerId, status, options).then((request) => request(axios, basePath));
        },
        getAllTransloads(options) {
            return localVarFp.getAllTransloads(options).then((request) => request(axios, basePath));
        },
        getBol(orderId, bolId, sellerId, options) {
            return localVarFp.getBol(orderId, bolId, sellerId, options).then((request) => request(axios, basePath));
        },
        getBolPdfUrl(bolId, options) {
            return localVarFp.getBolPdfUrl(bolId, options).then((request) => request(axios, basePath));
        },
        getBolTracking(bolId, options) {
            return localVarFp.getBolTracking(bolId, options).then((request) => request(axios, basePath));
        },
        getBolTrackingByBolId(bolId, options) {
            return localVarFp.getBolTrackingByBolId(bolId, options).then((request) => request(axios, basePath));
        },
        getBolTrackingByBolIdUnauthenticated(bolId, options) {
            return localVarFp.getBolTrackingByBolIdUnauthenticated(bolId, options).then((request) => request(axios, basePath));
        },
        getBolTrackingByFreightShipmentId(freightShipmentId, options) {
            return localVarFp.getBolTrackingByFreightShipmentId(freightShipmentId, options).then((request) => request(axios, basePath));
        },
        getBolTrackingUnauthenticated(bolId, options) {
            return localVarFp.getBolTrackingUnauthenticated(bolId, options).then((request) => request(axios, basePath));
        },
        getCheapestFreightRateConfig(cheapestRateConfigRequest, options) {
            return localVarFp.getCheapestFreightRateConfig(cheapestRateConfigRequest, options).then((request) => request(axios, basePath));
        },
        getContainerFreightStationV1(id, options) {
            return localVarFp.getContainerFreightStationV1(id, options).then((request) => request(axios, basePath));
        },
        getContainerFreightStationsV1(cursor, limit, direction, options) {
            return localVarFp.getContainerFreightStationsV1(cursor, limit, direction, options).then((request) => request(axios, basePath));
        },
        getCustomFieldData(id, options) {
            return localVarFp.getCustomFieldData(id, options).then((request) => request(axios, basePath));
        },
        getCustomer(sellerId, options) {
            return localVarFp.getCustomer(sellerId, options).then((request) => request(axios, basePath));
        },
        getCustomers(requestBody, options) {
            return localVarFp.getCustomers(requestBody, options).then((request) => request(axios, basePath));
        },
        getCustomersV2(sellerIds, options) {
            return localVarFp.getCustomersV2(sellerIds, options).then((request) => request(axios, basePath));
        },
        getEligibleFreightStrategies(eligibleFreightStrategyRequest, options) {
            return localVarFp.getEligibleFreightStrategies(eligibleFreightStrategyRequest, options).then((request) => request(axios, basePath));
        },
        getExistingLegByShipmentId(freightShipmentId, options) {
            return localVarFp.getExistingLegByShipmentId(freightShipmentId, options).then((request) => request(axios, basePath));
        },
        getFreightForwarder(id, options) {
            return localVarFp.getFreightForwarder(id, options).then((request) => request(axios, basePath));
        },
        getFreightForwarders(limit, cursor, direction, options) {
            return localVarFp.getFreightForwarders(limit, cursor, direction, options).then((request) => request(axios, basePath));
        },
        getFreightShipmentById(id, options) {
            return localVarFp.getFreightShipmentById(id, options).then((request) => request(axios, basePath));
        },
        getFreightShipmentByPalletLabelId(palletLabelId, options) {
            return localVarFp.getFreightShipmentByPalletLabelId(palletLabelId, options).then((request) => request(axios, basePath));
        },
        getFreightTrackingByBolIds(freightTrackingByBolIdsRequest, options) {
            return localVarFp.getFreightTrackingByBolIds(freightTrackingByBolIdsRequest, options).then((request) => request(axios, basePath));
        },
        getFreightTrackingInfo(sellerId, externalIdType, externalId, options) {
            return localVarFp.getFreightTrackingInfo(sellerId, externalIdType, externalId, options).then((request) => request(axios, basePath));
        },
        getLtlOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options) {
            return localVarFp.getLtlOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options).then((request) => request(axios, basePath));
        },
        getOceanRateCard(id, options) {
            return localVarFp.getOceanRateCard(id, options).then((request) => request(axios, basePath));
        },
        getOceanRateCards(limit, cursor, direction, id, freightForwarderId, shippingLine, pickupPortId, destinationPortId, price, transitDays, cargoUnit, expiresAt, createdAt, updatedAt, options) {
            return localVarFp.getOceanRateCards(limit, cursor, direction, id, freightForwarderId, shippingLine, pickupPortId, destinationPortId, price, transitDays, cargoUnit, expiresAt, createdAt, updatedAt, options).then((request) => request(axios, basePath));
        },
        getOrder(orderId, sellerId, options) {
            return localVarFp.getOrder(orderId, sellerId, options).then((request) => request(axios, basePath));
        },
        getOrderDocuments(orderId, sellerId, options) {
            return localVarFp.getOrderDocuments(orderId, sellerId, options).then((request) => request(axios, basePath));
        },
        getOrderItemBol(orderItemId, options) {
            return localVarFp.getOrderItemBol(orderItemId, options).then((request) => request(axios, basePath));
        },
        getOrderItemByShipmentId(freightShipmentId, options) {
            return localVarFp.getOrderItemByShipmentId(freightShipmentId, options).then((request) => request(axios, basePath));
        },
        getOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options) {
            return localVarFp.getOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options).then((request) => request(axios, basePath));
        },
        getOrderV1(orderId, sellerId, options) {
            return localVarFp.getOrderV1(orderId, sellerId, options).then((request) => request(axios, basePath));
        },
        getOrders(sellerId, limit, cursor, direction, options) {
            return localVarFp.getOrders(sellerId, limit, cursor, direction, options).then((request) => request(axios, basePath));
        },
        getOrdersV1(sellerId, limit, cursor, direction, options) {
            return localVarFp.getOrdersV1(sellerId, limit, cursor, direction, options).then((request) => request(axios, basePath));
        },
        getPalletLabelsByCarrierBolId(carrierBolId, paperSize, language, downloader, options) {
            return localVarFp.getPalletLabelsByCarrierBolId(carrierBolId, paperSize, language, downloader, options).then((request) => request(axios, basePath));
        },
        getPlan(freightPlanId, options) {
            return localVarFp.getPlan(freightPlanId, options).then((request) => request(axios, basePath));
        },
        getPlanFromHashId(freightPlanHashId, options) {
            return localVarFp.getPlanFromHashId(freightPlanHashId, options).then((request) => request(axios, basePath));
        },
        getPort(portId, options) {
            return localVarFp.getPort(portId, options).then((request) => request(axios, basePath));
        },
        getProfileByShipwellProfileId(shipwellProfileId, options) {
            return localVarFp.getProfileByShipwellProfileId(shipwellProfileId, options).then((request) => request(axios, basePath));
        },
        getQuote(quoteId, sellerId, options) {
            return localVarFp.getQuote(quoteId, sellerId, options).then((request) => request(axios, basePath));
        },
        getQuoteRequestById(quoteRequestId, sellerId, options) {
            return localVarFp.getQuoteRequestById(quoteRequestId, sellerId, options).then((request) => request(axios, basePath));
        },
        getQuoteRequests(sellerId, limit, offset, options) {
            return localVarFp.getQuoteRequests(sellerId, limit, offset, options).then((request) => request(axios, basePath));
        },
        getQuoteV1(quoteId, sellerId, options) {
            return localVarFp.getQuoteV1(quoteId, sellerId, options).then((request) => request(axios, basePath));
        },
        getQuotes(sellerId, limit, offset, cursor, direction, options) {
            return localVarFp.getQuotes(sellerId, limit, offset, cursor, direction, options).then((request) => request(axios, basePath));
        },
        getQuotesV1(sellerId, limit, offset, options) {
            return localVarFp.getQuotesV1(sellerId, limit, offset, options).then((request) => request(axios, basePath));
        },
        getRecentlyUsedAddresses(sellerId, pickup, options) {
            return localVarFp.getRecentlyUsedAddresses(sellerId, pickup, options).then((request) => request(axios, basePath));
        },
        getSellerPricingStrategiesAndRates(sellerId, options) {
            return localVarFp.getSellerPricingStrategiesAndRates(sellerId, options).then((request) => request(axios, basePath));
        },
        getStrategiesAndRatesForSellerRequest(sellerId, freightMode, fromZip, toZip, options) {
            return localVarFp.getStrategiesAndRatesForSellerRequest(sellerId, freightMode, fromZip, toZip, options).then((request) => request(axios, basePath));
        },
        getSupplier(supplierId, sellerId, options) {
            return localVarFp.getSupplier(supplierId, sellerId, options).then((request) => request(axios, basePath));
        },
        getSupplierContactsBySupplierId(supplierId, sellerId, cursor, limit, direction, options) {
            return localVarFp.getSupplierContactsBySupplierId(supplierId, sellerId, cursor, limit, direction, options).then((request) => request(axios, basePath));
        },
        getSupplierLocationsBySupplierId(supplierId, sellerId, cursor, limit, direction, options) {
            return localVarFp.getSupplierLocationsBySupplierId(supplierId, sellerId, cursor, limit, direction, options).then((request) => request(axios, basePath));
        },
        getSupplierProductsBySupplierId(sellerId, supplierId, cursor, limit, direction, options) {
            return localVarFp.getSupplierProductsBySupplierId(sellerId, supplierId, cursor, limit, direction, options).then((request) => request(axios, basePath));
        },
        getSuppliersBySellerId(sellerId, cursor, limit, direction, options) {
            return localVarFp.getSuppliersBySellerId(sellerId, cursor, limit, direction, options).then((request) => request(axios, basePath));
        },
        getTradingPartnerBookingFields(tradingPartner, mode, options) {
            return localVarFp.getTradingPartnerBookingFields(tradingPartner, mode, options).then((request) => request(axios, basePath));
        },
        getTransload(transloadId, options) {
            return localVarFp.getTransload(transloadId, options).then((request) => request(axios, basePath));
        },
        getWarehousesByAddressAndCapabilities(getWarehousesByAddressAndCapabilitiesRequest, options) {
            return localVarFp.getWarehousesByAddressAndCapabilities(getWarehousesByAddressAndCapabilitiesRequest, options).then((request) => request(axios, basePath));
        },
        markShipmentAsPendingForBilling(markShipmentAsPendingForBillingRequest, options) {
            return localVarFp.markShipmentAsPendingForBilling(markShipmentAsPendingForBillingRequest, options).then((request) => request(axios, basePath));
        },
        queueOrderByOrderId(orderId, options) {
            return localVarFp.queueOrderByOrderId(orderId, options).then((request) => request(axios, basePath));
        },
        rateShop(freightRequest, options) {
            return localVarFp.rateShop(freightRequest, options).then((request) => request(axios, basePath));
        },
        receiveAtCrossdock(poNum, receiveAtCrossdockRequest, options) {
            return localVarFp.receiveAtCrossdock(poNum, receiveAtCrossdockRequest, options).then((request) => request(axios, basePath));
        },
        receivePalletAtCrossdock(palletLabelId, receivePalletAtCrossdockRequest, options) {
            return localVarFp.receivePalletAtCrossdock(palletLabelId, receivePalletAtCrossdockRequest, options).then((request) => request(axios, basePath));
        },
        removeFeatureFlag(featureFlag, sellerId, options) {
            return localVarFp.removeFeatureFlag(featureFlag, sellerId, options).then((request) => request(axios, basePath));
        },
        setIsInternal(sellerId, isInternal, options) {
            return localVarFp.setIsInternal(sellerId, isInternal, options).then((request) => request(axios, basePath));
        },
        syncShipwellShipment(shipwellShipmentId, options) {
            return localVarFp.syncShipwellShipment(shipwellShipmentId, options).then((request) => request(axios, basePath));
        },
        syncShipwellShipmentByExternalId(externalShipmentId, options) {
            return localVarFp.syncShipwellShipmentByExternalId(externalShipmentId, options).then((request) => request(axios, basePath));
        },
        updateByShipmentId(freightShipmentId, updateLegRequest, options) {
            return localVarFp.updateByShipmentId(freightShipmentId, updateLegRequest, options).then((request) => request(axios, basePath));
        },
        updateContainerFreightStationV1(id, partialContainerFreightStationData, options) {
            return localVarFp.updateContainerFreightStationV1(id, partialContainerFreightStationData, options).then((request) => request(axios, basePath));
        },
        updateFlexportFreightTrackingInfoByProId(proId, partialFreightTrackingInfoData, options) {
            return localVarFp.updateFlexportFreightTrackingInfoByProId(proId, partialFreightTrackingInfoData, options).then((request) => request(axios, basePath));
        },
        updateFreightForwarder(id, partialFreightForwarderData, options) {
            return localVarFp.updateFreightForwarder(id, partialFreightForwarderData, options).then((request) => request(axios, basePath));
        },
        updateOceanRateCard(id, partialOceanRateCardData, options) {
            return localVarFp.updateOceanRateCard(id, partialOceanRateCardData, options).then((request) => request(axios, basePath));
        },
        updateOrCreateFreightTrackingInfo(sellerId, freightTrackingInfoData, options) {
            return localVarFp.updateOrCreateFreightTrackingInfo(sellerId, freightTrackingInfoData, options).then((request) => request(axios, basePath));
        },
        updatePort(portId, partialPortData, options) {
            return localVarFp.updatePort(portId, partialPortData, options).then((request) => request(axios, basePath));
        },
        updatePricingStrategies(updatePricingStrategyInput, options) {
            return localVarFp.updatePricingStrategies(updatePricingStrategyInput, options).then((request) => request(axios, basePath));
        },
        updatePricingStrategyRates(updatePricingStrategyRateInput, options) {
            return localVarFp.updatePricingStrategyRates(updatePricingStrategyRateInput, options).then((request) => request(axios, basePath));
        },
        updateProfile(shipwellProfileId, pickShipwellProfileStatus, options) {
            return localVarFp.updateProfile(shipwellProfileId, pickShipwellProfileStatus, options).then((request) => request(axios, basePath));
        },
        updateSupplierById(updateSupplierMerchantRequest, options) {
            return localVarFp.updateSupplierById(updateSupplierMerchantRequest, options).then((request) => request(axios, basePath));
        },
        updateSupplierContact(supplierId, supplierContactId, updateSupplierContactRequest, options) {
            return localVarFp.updateSupplierContact(supplierId, supplierContactId, updateSupplierContactRequest, options).then((request) => request(axios, basePath));
        },
        updateSupplierLocationById(supplierId, updateSupplierLocationRequest, options) {
            return localVarFp.updateSupplierLocationById(supplierId, updateSupplierLocationRequest, options).then((request) => request(axios, basePath));
        },
        updateSupplierProduct(supplierId, productId, updateSupplierProductRequest, options) {
            return localVarFp.updateSupplierProduct(supplierId, productId, updateSupplierProductRequest, options).then((request) => request(axios, basePath));
        },
        updateTransload(transloadId, partialTransloadFacilityData, options) {
            return localVarFp.updateTransload(transloadId, partialTransloadFacilityData, options).then((request) => request(axios, basePath));
        },
        uploadBolByExternalShipmentId(shipwellShipmentId, options) {
            return localVarFp.uploadBolByExternalShipmentId(shipwellShipmentId, options).then((request) => request(axios, basePath));
        },
        uploadCustomerBol(id, freightBolUploadRequest, options) {
            return localVarFp.uploadCustomerBol(id, freightBolUploadRequest, options).then((request) => request(axios, basePath));
        },
        upsertCustomer(customerData, options) {
            return localVarFp.upsertCustomer(customerData, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ServiceApiFactory = ServiceApiFactory;
class ServiceApi extends base_1.BaseAPI {
    addFeatureFlag(featureFlag, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).addFeatureFlag(featureFlag, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    cancel(orderId, cancelRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).cancel(orderId, cancelRequest, options).then((request) => request(this.axios, this.basePath));
    }
    cancelShipment(freightShipmentId, freightShipmentCancelRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).cancelShipment(freightShipmentId, freightShipmentCancelRequest, options).then((request) => request(this.axios, this.basePath));
    }
    create(orderRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).create(orderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createAddressLoadingDockScanEvent(loadingDockScanEventRequestWithAddress, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createAddressLoadingDockScanEvent(loadingDockScanEventRequestWithAddress, options).then((request) => request(this.axios, this.basePath));
    }
    createContainerFreightStationV1(containerFreightStationData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createContainerFreightStationV1(containerFreightStationData, options).then((request) => request(this.axios, this.basePath));
    }
    createDrayage(drayageRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createDrayage(drayageRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createDrayageOrder(drayageOrderRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createDrayageOrder(drayageOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createFclOrder(fclOrderRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createFclOrder(fclOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createFreightForwarder(freightForwarderData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createFreightForwarder(freightForwarderData, options).then((request) => request(this.axios, this.basePath));
    }
    createFreightTrackingInfo(sellerId, freightTrackingInfoData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createFreightTrackingInfo(sellerId, freightTrackingInfoData, options).then((request) => request(this.axios, this.basePath));
    }
    createFtl(ftlRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createFtl(ftlRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createFtlOrder(ftlOrderRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createFtlOrder(ftlOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options).then((request) => request(this.axios, this.basePath));
    }
    createLtl(ltlRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createLtl(ltlRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createLtlMetroPickupAndDeliveryShipment(freightLtlRequestWithCustomFieldsTsoaFix, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createLtlMetroPickupAndDeliveryShipment(freightLtlRequestWithCustomFieldsTsoaFix, options).then((request) => request(this.axios, this.basePath));
    }
    createLtlOrder(ltlOrderRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createLtlOrder(ltlOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createLtlShipment(freightLtlRequestWithCustomFieldsTsoaFix, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createLtlShipment(freightLtlRequestWithCustomFieldsTsoaFix, options).then((request) => request(this.axios, this.basePath));
    }
    createOceanRateCard(oceanRateCardData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createOceanRateCard(oceanRateCardData, options).then((request) => request(this.axios, this.basePath));
    }
    createPartialFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createPartialFtlShipment(freightFtlRequestWithCustomFieldsTsoaFix, options).then((request) => request(this.axios, this.basePath));
    }
    createPort(portData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createPort(portData, options).then((request) => request(this.axios, this.basePath));
    }
    createPricingStrategies(pricingStrategyDataWithRateData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createPricingStrategies(pricingStrategyDataWithRateData, options).then((request) => request(this.axios, this.basePath));
    }
    createProfile(shipwellProfileCreatedEvent, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createProfile(shipwellProfileCreatedEvent, options).then((request) => request(this.axios, this.basePath));
    }
    createShipments(freightShipmentsCreateRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createShipments(freightShipmentsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createSupplier(supplierMerchantData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createSupplier(supplierMerchantData, options).then((request) => request(this.axios, this.basePath));
    }
    createSupplierContact(supplierId, createSupplierContactRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createSupplierContact(supplierId, createSupplierContactRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createSupplierLocation(supplierId, createSupplierLocationRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createSupplierLocation(supplierId, createSupplierLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createSupplierProduct(supplierId, createSupplierProductRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createSupplierProduct(supplierId, createSupplierProductRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createTransload(transloadFacilityData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createTransload(transloadFacilityData, options).then((request) => request(this.axios, this.basePath));
    }
    createWarehouseLoadingDockScanEvent(loadingDockScanEventRequestWithWarehouseId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createWarehouseLoadingDockScanEvent(loadingDockScanEventRequestWithWarehouseId, options).then((request) => request(this.axios, this.basePath));
    }
    deleteContainerFreightStationV1(id, options) {
        return (0, exports.ServiceApiFp)(this.configuration).deleteContainerFreightStationV1(id, options).then((request) => request(this.axios, this.basePath));
    }
    deleteOceanRateCard(id, options) {
        return (0, exports.ServiceApiFp)(this.configuration).deleteOceanRateCard(id, options).then((request) => request(this.axios, this.basePath));
    }
    deleteSupplier(supplierId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).deleteSupplier(supplierId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    deleteSupplierContact(supplierId, supplierContactId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).deleteSupplierContact(supplierId, supplierContactId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    deleteSupplierLocation(supplierId, supplierLocationId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).deleteSupplierLocation(supplierId, supplierLocationId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    deleteSupplierProduct(supplierId, sellerId, productId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).deleteSupplierProduct(supplierId, sellerId, productId, options).then((request) => request(this.axios, this.basePath));
    }
    dispatchByFreightRateId(freightRateId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).dispatchByFreightRateId(freightRateId, options).then((request) => request(this.axios, this.basePath));
    }
    enqueueMothershipWebhookEvent(body, options) {
        return (0, exports.ServiceApiFp)(this.configuration).enqueueMothershipWebhookEvent(body, options).then((request) => request(this.axios, this.basePath));
    }
    enqueueOpenTrackWebhookEvent(body, options) {
        return (0, exports.ServiceApiFp)(this.configuration).enqueueOpenTrackWebhookEvent(body, options).then((request) => request(this.axios, this.basePath));
    }
    enqueueShipwellWebhookEvent(body, options) {
        return (0, exports.ServiceApiFp)(this.configuration).enqueueShipwellWebhookEvent(body, options).then((request) => request(this.axios, this.basePath));
    }
    generateChargeReportForSID(freightShipmentChargeReportRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateChargeReportForSID(freightShipmentChargeReportRequest, options).then((request) => request(this.axios, this.basePath));
    }
    generateDrayageQuote(drayageQuoteRequestV2, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateDrayageQuote(drayageQuoteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
    generateFreightPlan(freightPlanRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateFreightPlan(freightPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }
    generateFreightPlanHashId(freightPlanId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateFreightPlanHashId(freightPlanId, options).then((request) => request(this.axios, this.basePath));
    }
    generateFreightQuote(freightQuoteRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateFreightQuote(freightQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    generateFtlQuote(ftlQuoteRequestV2, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateFtlQuote(ftlQuoteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
    generateFtlQuoteV2(ftlQuoteRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateFtlQuoteV2(ftlQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    generateIntlOceanQuote(intlOceanQuoteRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateIntlOceanQuote(intlOceanQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    generateLtlBatchQuote(ltlBatchQuoteRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateLtlBatchQuote(ltlBatchQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    generateLtlQuote(ltlQuoteRequestV2, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateLtlQuote(ltlQuoteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
    generateLtlQuoteV2(ltlQuoteRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateLtlQuoteV2(ltlQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    generatePalletLabels(sellerId, shippingPlanId, language, paperSize, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generatePalletLabels(sellerId, shippingPlanId, language, paperSize, options).then((request) => request(this.axios, this.basePath));
    }
    generateQuote(quoteRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateQuote(quoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    generateQuotes(requestForQuote, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateQuotes(requestForQuote, options).then((request) => request(this.axios, this.basePath));
    }
    getAllPorts(options) {
        return (0, exports.ServiceApiFp)(this.configuration).getAllPorts(options).then((request) => request(this.axios, this.basePath));
    }
    getAllProfilesBySellerId(sellerId, status, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getAllProfilesBySellerId(sellerId, status, options).then((request) => request(this.axios, this.basePath));
    }
    getAllTransloads(options) {
        return (0, exports.ServiceApiFp)(this.configuration).getAllTransloads(options).then((request) => request(this.axios, this.basePath));
    }
    getBol(orderId, bolId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getBol(orderId, bolId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getBolPdfUrl(bolId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getBolPdfUrl(bolId, options).then((request) => request(this.axios, this.basePath));
    }
    getBolTracking(bolId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getBolTracking(bolId, options).then((request) => request(this.axios, this.basePath));
    }
    getBolTrackingByBolId(bolId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getBolTrackingByBolId(bolId, options).then((request) => request(this.axios, this.basePath));
    }
    getBolTrackingByBolIdUnauthenticated(bolId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getBolTrackingByBolIdUnauthenticated(bolId, options).then((request) => request(this.axios, this.basePath));
    }
    getBolTrackingByFreightShipmentId(freightShipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getBolTrackingByFreightShipmentId(freightShipmentId, options).then((request) => request(this.axios, this.basePath));
    }
    getBolTrackingUnauthenticated(bolId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getBolTrackingUnauthenticated(bolId, options).then((request) => request(this.axios, this.basePath));
    }
    getCheapestFreightRateConfig(cheapestRateConfigRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getCheapestFreightRateConfig(cheapestRateConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getContainerFreightStationV1(id, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getContainerFreightStationV1(id, options).then((request) => request(this.axios, this.basePath));
    }
    getContainerFreightStationsV1(cursor, limit, direction, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getContainerFreightStationsV1(cursor, limit, direction, options).then((request) => request(this.axios, this.basePath));
    }
    getCustomFieldData(id, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getCustomFieldData(id, options).then((request) => request(this.axios, this.basePath));
    }
    getCustomer(sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getCustomer(sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getCustomers(requestBody, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getCustomers(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    getCustomersV2(sellerIds, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getCustomersV2(sellerIds, options).then((request) => request(this.axios, this.basePath));
    }
    getEligibleFreightStrategies(eligibleFreightStrategyRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getEligibleFreightStrategies(eligibleFreightStrategyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getExistingLegByShipmentId(freightShipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getExistingLegByShipmentId(freightShipmentId, options).then((request) => request(this.axios, this.basePath));
    }
    getFreightForwarder(id, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getFreightForwarder(id, options).then((request) => request(this.axios, this.basePath));
    }
    getFreightForwarders(limit, cursor, direction, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getFreightForwarders(limit, cursor, direction, options).then((request) => request(this.axios, this.basePath));
    }
    getFreightShipmentById(id, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getFreightShipmentById(id, options).then((request) => request(this.axios, this.basePath));
    }
    getFreightShipmentByPalletLabelId(palletLabelId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getFreightShipmentByPalletLabelId(palletLabelId, options).then((request) => request(this.axios, this.basePath));
    }
    getFreightTrackingByBolIds(freightTrackingByBolIdsRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getFreightTrackingByBolIds(freightTrackingByBolIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getFreightTrackingInfo(sellerId, externalIdType, externalId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getFreightTrackingInfo(sellerId, externalIdType, externalId, options).then((request) => request(this.axios, this.basePath));
    }
    getLtlOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getLtlOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getOceanRateCard(id, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOceanRateCard(id, options).then((request) => request(this.axios, this.basePath));
    }
    getOceanRateCards(limit, cursor, direction, id, freightForwarderId, shippingLine, pickupPortId, destinationPortId, price, transitDays, cargoUnit, expiresAt, createdAt, updatedAt, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOceanRateCards(limit, cursor, direction, id, freightForwarderId, shippingLine, pickupPortId, destinationPortId, price, transitDays, cargoUnit, expiresAt, createdAt, updatedAt, options).then((request) => request(this.axios, this.basePath));
    }
    getOrder(orderId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrder(orderId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getOrderDocuments(orderId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrderDocuments(orderId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getOrderItemBol(orderItemId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrderItemBol(orderItemId, options).then((request) => request(this.axios, this.basePath));
    }
    getOrderItemByShipmentId(freightShipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrderItemByShipmentId(freightShipmentId, options).then((request) => request(this.axios, this.basePath));
    }
    getOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrderItemPalletLabels(orderItemId, paperSize, language, downloader, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getOrderV1(orderId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrderV1(orderId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getOrders(sellerId, limit, cursor, direction, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrders(sellerId, limit, cursor, direction, options).then((request) => request(this.axios, this.basePath));
    }
    getOrdersV1(sellerId, limit, cursor, direction, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrdersV1(sellerId, limit, cursor, direction, options).then((request) => request(this.axios, this.basePath));
    }
    getPalletLabelsByCarrierBolId(carrierBolId, paperSize, language, downloader, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getPalletLabelsByCarrierBolId(carrierBolId, paperSize, language, downloader, options).then((request) => request(this.axios, this.basePath));
    }
    getPlan(freightPlanId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getPlan(freightPlanId, options).then((request) => request(this.axios, this.basePath));
    }
    getPlanFromHashId(freightPlanHashId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getPlanFromHashId(freightPlanHashId, options).then((request) => request(this.axios, this.basePath));
    }
    getPort(portId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getPort(portId, options).then((request) => request(this.axios, this.basePath));
    }
    getProfileByShipwellProfileId(shipwellProfileId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getProfileByShipwellProfileId(shipwellProfileId, options).then((request) => request(this.axios, this.basePath));
    }
    getQuote(quoteId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getQuote(quoteId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getQuoteRequestById(quoteRequestId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getQuoteRequestById(quoteRequestId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getQuoteRequests(sellerId, limit, offset, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getQuoteRequests(sellerId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    getQuoteV1(quoteId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getQuoteV1(quoteId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getQuotes(sellerId, limit, offset, cursor, direction, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getQuotes(sellerId, limit, offset, cursor, direction, options).then((request) => request(this.axios, this.basePath));
    }
    getQuotesV1(sellerId, limit, offset, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getQuotesV1(sellerId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    getRecentlyUsedAddresses(sellerId, pickup, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getRecentlyUsedAddresses(sellerId, pickup, options).then((request) => request(this.axios, this.basePath));
    }
    getSellerPricingStrategiesAndRates(sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getSellerPricingStrategiesAndRates(sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getStrategiesAndRatesForSellerRequest(sellerId, freightMode, fromZip, toZip, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getStrategiesAndRatesForSellerRequest(sellerId, freightMode, fromZip, toZip, options).then((request) => request(this.axios, this.basePath));
    }
    getSupplier(supplierId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getSupplier(supplierId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    getSupplierContactsBySupplierId(supplierId, sellerId, cursor, limit, direction, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getSupplierContactsBySupplierId(supplierId, sellerId, cursor, limit, direction, options).then((request) => request(this.axios, this.basePath));
    }
    getSupplierLocationsBySupplierId(supplierId, sellerId, cursor, limit, direction, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getSupplierLocationsBySupplierId(supplierId, sellerId, cursor, limit, direction, options).then((request) => request(this.axios, this.basePath));
    }
    getSupplierProductsBySupplierId(sellerId, supplierId, cursor, limit, direction, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getSupplierProductsBySupplierId(sellerId, supplierId, cursor, limit, direction, options).then((request) => request(this.axios, this.basePath));
    }
    getSuppliersBySellerId(sellerId, cursor, limit, direction, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getSuppliersBySellerId(sellerId, cursor, limit, direction, options).then((request) => request(this.axios, this.basePath));
    }
    getTradingPartnerBookingFields(tradingPartner, mode, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getTradingPartnerBookingFields(tradingPartner, mode, options).then((request) => request(this.axios, this.basePath));
    }
    getTransload(transloadId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getTransload(transloadId, options).then((request) => request(this.axios, this.basePath));
    }
    getWarehousesByAddressAndCapabilities(getWarehousesByAddressAndCapabilitiesRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getWarehousesByAddressAndCapabilities(getWarehousesByAddressAndCapabilitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    markShipmentAsPendingForBilling(markShipmentAsPendingForBillingRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).markShipmentAsPendingForBilling(markShipmentAsPendingForBillingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    queueOrderByOrderId(orderId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).queueOrderByOrderId(orderId, options).then((request) => request(this.axios, this.basePath));
    }
    rateShop(freightRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).rateShop(freightRequest, options).then((request) => request(this.axios, this.basePath));
    }
    receiveAtCrossdock(poNum, receiveAtCrossdockRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).receiveAtCrossdock(poNum, receiveAtCrossdockRequest, options).then((request) => request(this.axios, this.basePath));
    }
    receivePalletAtCrossdock(palletLabelId, receivePalletAtCrossdockRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).receivePalletAtCrossdock(palletLabelId, receivePalletAtCrossdockRequest, options).then((request) => request(this.axios, this.basePath));
    }
    removeFeatureFlag(featureFlag, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).removeFeatureFlag(featureFlag, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    setIsInternal(sellerId, isInternal, options) {
        return (0, exports.ServiceApiFp)(this.configuration).setIsInternal(sellerId, isInternal, options).then((request) => request(this.axios, this.basePath));
    }
    syncShipwellShipment(shipwellShipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).syncShipwellShipment(shipwellShipmentId, options).then((request) => request(this.axios, this.basePath));
    }
    syncShipwellShipmentByExternalId(externalShipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).syncShipwellShipmentByExternalId(externalShipmentId, options).then((request) => request(this.axios, this.basePath));
    }
    updateByShipmentId(freightShipmentId, updateLegRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateByShipmentId(freightShipmentId, updateLegRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateContainerFreightStationV1(id, partialContainerFreightStationData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateContainerFreightStationV1(id, partialContainerFreightStationData, options).then((request) => request(this.axios, this.basePath));
    }
    updateFlexportFreightTrackingInfoByProId(proId, partialFreightTrackingInfoData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateFlexportFreightTrackingInfoByProId(proId, partialFreightTrackingInfoData, options).then((request) => request(this.axios, this.basePath));
    }
    updateFreightForwarder(id, partialFreightForwarderData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateFreightForwarder(id, partialFreightForwarderData, options).then((request) => request(this.axios, this.basePath));
    }
    updateOceanRateCard(id, partialOceanRateCardData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateOceanRateCard(id, partialOceanRateCardData, options).then((request) => request(this.axios, this.basePath));
    }
    updateOrCreateFreightTrackingInfo(sellerId, freightTrackingInfoData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateOrCreateFreightTrackingInfo(sellerId, freightTrackingInfoData, options).then((request) => request(this.axios, this.basePath));
    }
    updatePort(portId, partialPortData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updatePort(portId, partialPortData, options).then((request) => request(this.axios, this.basePath));
    }
    updatePricingStrategies(updatePricingStrategyInput, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updatePricingStrategies(updatePricingStrategyInput, options).then((request) => request(this.axios, this.basePath));
    }
    updatePricingStrategyRates(updatePricingStrategyRateInput, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updatePricingStrategyRates(updatePricingStrategyRateInput, options).then((request) => request(this.axios, this.basePath));
    }
    updateProfile(shipwellProfileId, pickShipwellProfileStatus, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateProfile(shipwellProfileId, pickShipwellProfileStatus, options).then((request) => request(this.axios, this.basePath));
    }
    updateSupplierById(updateSupplierMerchantRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateSupplierById(updateSupplierMerchantRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateSupplierContact(supplierId, supplierContactId, updateSupplierContactRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateSupplierContact(supplierId, supplierContactId, updateSupplierContactRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateSupplierLocationById(supplierId, updateSupplierLocationRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateSupplierLocationById(supplierId, updateSupplierLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateSupplierProduct(supplierId, productId, updateSupplierProductRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateSupplierProduct(supplierId, productId, updateSupplierProductRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateTransload(transloadId, partialTransloadFacilityData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateTransload(transloadId, partialTransloadFacilityData, options).then((request) => request(this.axios, this.basePath));
    }
    uploadBolByExternalShipmentId(shipwellShipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).uploadBolByExternalShipmentId(shipwellShipmentId, options).then((request) => request(this.axios, this.basePath));
    }
    uploadCustomerBol(id, freightBolUploadRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).uploadCustomerBol(id, freightBolUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }
    upsertCustomer(customerData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).upsertCustomer(customerData, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ServiceApi = ServiceApi;
//# sourceMappingURL=service-api.js.map